<template>
  <div>
    <div class="protocol" v-if="!(listTasks || listTasksDTT || listTasksMand || listTasksUSD || listTasksChain || listTasksShaping || listTasksPecsWithDiscrimination)">
      <div class="row top-button form-group-button">
        <div class="col-md-12">
          <router-link class="btn btn-light btn-sm back"
                       v-if="clientId || protocol.assigneeId"
                       :to="{ name: 'client-edit', params: { clientId: clientId || protocol.assigneeId}}">
            <i class="material-icons mdc-button__icon">arrow_back</i>
            <span>{{'buttons.back_to_client' | trans}} {{client.code}} ({{client.hash}})</span>
          </router-link>
          <router-link class="btn btn-light btn-sm back" v-else
                       :to="{ name: 'protocols'}">
            <i class="material-icons mdc-button__icon">arrow_back</i>
            <span>{{'buttons.back' | trans}}</span>
          </router-link>

          <button v-if="protocol.isDraft" type="submit"
                  class="btn btn-primary btn-sm ml-0 ml-md-2 mb-2"
                  @click.prevent="editProtocol(isMand ? true : protocol.published)">
            {{'protocol.buttons.apply_changes_to_protocol' | trans}}
          </button>
          <button v-if="!isNew && !protocol.isDraft" type="submit"
                  class="btn btn-primary btn-sm ml-0 ml-md-2 mb-2"
                  @click.prevent="editProtocol(true)"
                  :disabled="!protocol.stages.length">
            {{'protocol.buttons.save' | trans}}
          </button>
          <button v-if="isNew && !protocol.isDraft" type="submit"
                  class="btn btn-primary btn-sm ml-0 ml-md-2 mb-2"
                  @click.prevent="createProtocol(true)"
                  :disabled="!canPublish">
            {{'protocol.buttons.create' | trans}}
          </button>
          <button
              v-if="!(isNew) && !(clientId || protocol.assigneeId) && !protocol.isDraft"
              type="submit"
              class="btn btn-link btn-sm ml-0 ml-md-2 mb-2"
              @click.prevent="editProtocol(false)"
              :disabled="disabled">
            {{'protocol.buttons.createNotPublish' | trans}}
          </button>
          <button v-if="(isNew) && !protocol.isDraft"
                  type="submit"
                  class="btn btn-link btn-sm ml-0 ml-md-2 mb-2"
                  @click.prevent="createProtocol(false)"
                  :disabled="disabled">
            {{'protocol.buttons.createNotPublish' | trans}}
          </button>
          <button v-if="protocol.isOnIndividualization"
                  type="submit"
                  class="btn btn-primary btn-sm ml-0 ml-md-2 mb-2"
                  @click.prevent="saveAndAllowMensuration()"
                  :disabled="disabled">
            {{'protocol.buttons.save_and_allow_mensuration' | trans}}
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <h1 v-if="isNew && !protocol.isDraft" class="page-title">
            {{'protocol.newProtocol' |
            trans}}</h1>
          <h1 v-if="!isNew && !protocol.isDraft" class="page-title">
            {{'protocol.editProtocol' |
            trans}}</h1>
          <h1 v-if="protocol.isDraft" class="page-title">
            {{'protocol.auto_save_version' | trans}} {{
            toLocaleDateTimeTimezone(protocol.updatedAt.date)}}</h1>
          <h3 class="page-sub-title">{{'protocol.descriptionPart' | trans}}</h3>
        </div>
      </div>

      <loader v-if="!isLoaded"></loader>

      <div class="row">
        <div class="col-md-9">
          <!-----title----->
          <!----select level 1 ----->
          <div class="form-group row">
            <div class="col-md-6">
              <v-select name="teachingMethod"
                        :options="directories"
                        label="name"
                        :disabled="disabledTeachingMethod"
                        :class="{'is-clear': !teachingMethod}"
                        v-model="teachingMethod">
                <span slot="no-options">{{'protocol.noAvailableTeachingMethod' | trans}}</span>
              </v-select>
              <label class="mdc-floating-label">{{'protocol.recording_method' | trans}}</label>
            </div>
          </div>
          <!----select level 1 ----->
        </div>
      </div>



      <div class="row" v-if="teachingMethod">
          <div class="col-md-9">

          <protocol-info
            :protocol="protocol"
            :setIsChanged="setIsChanged"
            :visible="visible"
            :errors="errors"
            :selectedTeachingMethodID="selectedTeachingMethodID"
          />

          <!----------- stages ------------------->

          <div class="form-group row" v-if="!isPecs && !isPecsWithoutDiscrimination && !isPecsWithDiscrimination && !isPecsWithItems">
            <div class="col-md-12"  v-if="!isChain && !isShaping">
              <h4 class="row-title mt-3">{{'protocol.stages' | trans}}</h4>
              <h5 class="row-title_subsitle">{{'protocol.change_stage_position' | trans}}</h5>
            </div>
            <div class="col-md-12"  v-if="isChain || isShaping">
              <h4 class="row-title mt-3">{{'protocol.environments' | trans}}</h4>
              <h5 class="row-title_subsitle">{{'protocol.change_environment_position' | trans}}</h5>
            </div>
          </div>

          <div class="stages" id="stages" ref="stages"
               v-if="('stages' in protocol) && !isPecs && !isPecsWithoutDiscrimination && !isPecsWithItems">

            <draggable
                v-if="!isPecsWithDiscrimination"
                :list="protocol.stages"
                ghost-class="ghost"
                @start="dragging = true"
                @end="dragging = false"
                :move="onMoveStages"
                handle=".drag-btn"
            >

              <div v-for="(value, key) in protocol.stages">
                <div class="form-group row dragging">
                  <div class="col-md-2 text-center stages-col" v-if="!isMobile">
                    <span class="badge badge-info">{{key + 1}}</span>
                    <p>{{isChain  || isShaping ? 'protocol.environment' : 'protocol.stage' | trans}} {{key + 1}}</p>
                  </div>
                  <div class="col-md-5 col-10">
                    <mdc-textfield type="text"
                                   :id="'stage_' + key"
                                   :ref="'stage_' + key"
                                   :label="isChain || isShaping ? 'protocol.describeEnvironment' : 'protocol.describeStage', {number: key + 1} | trans"
                                   :name="'stage_' + key"
                                   :class="{'is-invalid': errors.has('stage_' + key)}"
                                   class="required"
                                   v-validate="'required|max:1000|unique_stage'"
                                   v-model="protocol.stages[key].description"
                                   v-on:keyup.enter="addStage()"
                                   v-on:change="setStageDescription(value,$event)"
                                   data-vv-validate-on="none"
                                   :data-vv-as="isChain || isShaping ? 'protocol.environment' : 'protocol.stage' | trans"
                                   :disabled="value.isClosed"/>
                    <span class="invalid-feedback"
                          v-if="errors.has('stage_' + key)">
                      <strong>{{ errors.first('stage_' + key) }}</strong>
                  </span>
                    <strong class="invalid-feedback invalid"  v-if="!errorStages && value.notValid">{{'protocol.errorStages' | trans}}</strong>

                    <button type="button"
                            class="btn btn-link secondary-link btn-sm"
                            @click.prevent="removeStage(key)"
                            v-if="!value.hasAssignedStage && isMobile  && protocol.stages.length>1">
                      {{isChain || isShaping ? 'protocol.removeEnvironment': 'protocol.buttons.removeStage' | trans}}
                    </button>
                    <button type="submit" v-if="((value.tasks && value.tasks.length) || (value.stimuli && value.stimuli.length) || (isChain && protocol.globalTasks && protocol.globalTasks.length)) && !isMand && isMobile"
                            class="btn btn-primary btn-rounded copy-btn ml-1 float-right"
                            @click.prevent="duplicateStage(protocol.stages[key])">
                    </button>
                    <button type="submit" v-if="value.mands && value.mands.length && isMand && isMobile"
                            class="btn btn-primary btn-rounded copy-btn ml-1 float-right"
                            @click.prevent="duplicateStage(protocol.stages[key])">
                    </button>
                    <button type="submit"  v-if="isMobile && !isMand"
                            class="btn btn-primary btn-rounded edit-btn ml-1 float-right"
                            @click.prevent="showTasks(protocol.stages[key])"
                            :disabled="value.isClosed">
                    </button>
                    <button type="submit" v-if="isMobile && isMand"
                            class="btn btn-primary btn-rounded edit-btn ml-1 float-right"
                            @click.prevent="showMands(protocol.stages[key])"
                            :disabled="value.isClosed">
                    </button>
                  </div>

                  <div class="col-2 text-center" v-if="isMobile">
                    <span class="drag-btn" v-if="!value.isClosed && isMobile ">draggable</span>
                  </div>

                  <div class="col-md-5"   v-if="!isMobile">
                    <button type="button"
                            class="btn btn-link secondary-link btn-sm"
                            @click.prevent="removeStage(key)"
                            v-if="!value.hasAssignedStage && protocol.stages.length>1">
                      {{isChain || isShaping ? 'protocol.removeEnvironment': 'protocol.buttons.removeStage' | trans}}
                    </button>
                    <button type="submit" v-if="!isMand"
                            class="btn btn-primary btn-rounded edit-btn ml-1"
                            @click.prevent="showTasks(protocol.stages[key])"
                            :disabled="value.isClosed">
                    </button>
                    <button type="submit" v-if="isMand"
                            class="btn btn-primary btn-rounded edit-btn ml-1"
                            @click.prevent="showMands(protocol.stages[key])"
                            :disabled="value.isClosed">
                    </button>
                    <button type="submit" v-if="((value.tasks && value.tasks.length) || (value.stimuli && value.stimuli.length) || (isChain && protocol.globalTasks && protocol.globalTasks.length))  && !isMand"
                            class="btn btn-primary btn-rounded copy-btn ml-1"
                            @click.prevent="duplicateStage(protocol.stages[key])">
                    </button>
                    <button type="submit" v-if="value.mands && value.mands.length && isMand"
                            class="btn btn-primary btn-rounded copy-btn ml-1"
                            @click.prevent="duplicateStage(protocol.stages[key])">
                    </button>
                    <span class="drag-btn align-top ml-1" v-if="!value.isClosed && !isMobile">draggable</span>

                  </div>
                </div>

              </div>
            </draggable>

            <div class="form-group row" v-if="isPecsWithDiscrimination">
              <div class="col-md-12">
                <h4 class="row-title mt-3">{{'protocol.count_properties' | trans}}</h4>
              </div>
            </div>

            <div v-if="isPecsWithDiscrimination" v-for="(value, key) in protocol.stages">

              <div class="form-group row without-line">
                <div class="col-2 text-center stages-col" v-if="!isMobile">
                  <span class="badge badge-info mt-2">{{key + 1}}</span>
                </div>
                <div class="col-10 pt-2 pb-2">

                  <button type="submit"
                          class="btn btn-primary btn-rounded edit-btn ml-1 float-right"
                          @click.prevent="showTasks(protocol.stages[key])"
                          :disabled="!value.isActive">
                  </button>

                  <mdc-checkbox v-model="value.isActive" :disabled="activeStages.length == 1 && value.isActive" class="float-right"/>

                  <p class="mb-0 mt-1">{{'protocol.count_properties' | trans}} {{key + 1}}</p>
                  <span class="invalid-feedback"
                        v-if="errors.has('stage_' + key)">
                      <strong>{{ errors.first('stage_' + key) }}</strong>
                  </span>

                </div>

              </div>
            </div>


            <div class="form-group row" v-if="!isPecsWithoutDiscrimination && !isPecsWithDiscrimination">
              <div class="col-md-2 text-center stages-col" v-if="!isMobile">
                <span class="badge badge-secondary">{{protocol.stages.length + 1}}</span>
                <p   v-if="!isChain && !isShaping">{{'protocol.stage' | trans}}
                  {{protocol.stages.length + 1}}</p>
                <p   v-if="isChain || isShaping">{{'protocol.environment' | trans}}
                  {{protocol.stages.length + 1}}</p>
              </div>
              <div class="col-md-10">
                <button type="button"  v-if="!isChain && !isShaping"
                        class="btn btn-info"
                        @click.prevent="addStage()">
                  {{'protocol.buttons.addStage' | trans}}
                </button>
                <button type="button"  v-if="isChain || isShaping"
                        class="btn btn-info"
                        @click.prevent="addStage()">
                  {{'protocol.addEnvironment' | trans}}
                </button>
              </div>
            </div>

            <div class="form-group row" v-if="!validateStimuls && isChain">
              <div class="col-md-10">
                <strong class="text-danger">{{ 'protocol.requiredStepsList' | trans }}</strong>
              </div>
            </div>

            <div class="form-group row" v-if="!validateStimuls && !isChain">
              <div class="col-md-10">
                <strong class="text-danger">{{ 'protocol.requiredStimulList' | trans }}</strong>
              </div>
            </div>

            <div class="form-group row" v-if="!validateCheckList">
              <div class="col-md-10">
                <strong class="text-danger">{{ 'protocol.requiredCheckList' | trans }}</strong>
              </div>
            </div>

          </div>



          <div class="row" v-if="!isPecs && !isPecsWithoutDiscrimination && !isPecsWithDiscrimination && !isPecsWithItems">
            <div class="col-12">
              <strong class="invalid-feedback invalid"  v-if="!errorStagesCount && !isChain">
                {{!isChain ? 'protocol.errorStagesCount' :  'protocol.errorEnvironmentsCount' | trans}}
              </strong>
            </div>
          </div>
          <div class="stages row" v-if="('stages' in protocol) && (isPecs || isPecsWithoutDiscrimination)">
            <tasks-pecs :protocol="protocol" :teaching-method="teachingMethod" />
          </div>

          <criteria-pecs :protocol="protocol" v-if="isPecsWithDiscrimination" @removed="onChangeRemovedCategoryCount"/>

          <criteria-pecs-items :protocol="protocol" v-if="isPecsWithItems && protocol.categories && protocol.categories.length"  @removed="onChangeRemovedCategoryCount"/>

          <!----------- tasks ------------------->
          <div class="mt-2"
               v-if="!isMand && !isPecs && !isPecsWithoutDiscrimination && !isPecsWithDiscrimination && !isPecsWithItems">
            <div class="form-group row">
              <div class="col-md-12">
                <h4 class="row-title">{{!isChain ? !isShaping ? 'protocol.stimuluses' : 'protocol.criterion' : 'protocol.steps' | trans}}</h4>
                <h5 class="row-title_subsitle">{{!isChain ? !isShaping ? 'protocol.change_stimul_position' : 'protocol.change_criterion_position' : 'protocol.change_step_position' | trans}}</h5>
              </div>
              <div class="tasks col-md-12" id="tasks" v-if="protocol.globalTasks">
                <draggable
                    :list="protocol.globalTasks"
                    ghost-class="ghost"
                    @start="draggingGlobalTasks = true"
                    @end="draggingGlobalTasks = false"
                    handle=".drag-btn"
                >
                  <div v-for="(value, key) in protocol.globalTasks" class="alert-secondary dragging-block">
                    <div class="form-group row dragging">
                      <div class="col-md-9 col-10">
                        <mdc-textfield type="text"
                                       :ref="'task_' + key"
                                       :name="'task_' + key"
                                       :label="isChain ? 'protocol.describeStep' : isShaping ? 'protocol.describeСriterion' : 'protocol.describeStimulus', {number: key + 1} | trans"
                                       class="required"
                                       :class="{'is-invalid': errors.has('task_' + key)}"
                                       v-validate="'required|max:1000|unique_task'"
                                       v-model="value.description"
                                       data-vv-validate-on="none"
                                       v-on:focus="focusStageTaskDescription(value)"
                                       v-on:change="setStageTaskDescription(value,$event)"
                                       v-on:input="setIsChanged(false)"
                                       :data-vv-as="isChain ? 'protocol.step' : isShaping ? 'protocol.criterion' : 'validation.attributes.task' | trans"/>
                        <span class="invalid-feedback"
                              v-if="errors.has('task_' + key)">
                                    <strong>{{ errors.first('task_' + key) }}</strong>
                                </span>

                        <button type="button"
                                v-if="(showDeleteButton || value.isNew || isCurator || isBCBA) && key && isMobile"
                                class="btn btn-link secondary-link btn-sm"
                                @click.prevent="removeTaskModal(protocol.globalTasks[key].uuid)">
                          {{isChain ? 'protocol.removeStep' : isShaping ? 'protocol.buttons.removeСriterion' : 'protocol.buttons.removeStimulus'  | trans}}
                        </button>
                      </div>
                      <div class="col-2 text-center" v-if="isMobile">
                        <span class="drag-btn">draggable</span>
                      </div>
                      <div class="col-md-3 pr-2" v-if="!isMobile">
                        <button type="button"
                                v-if="(showDeleteButton || value.isNew || isCurator || isBCBA) && key"
                                class="btn btn-link secondary-link btn-sm"
                                @click.prevent="removeTaskModal(protocol.globalTasks[key].uuid)">
                          {{isChain ? 'protocol.removeStep' : isShaping ? 'protocol.buttons.removeСriterion' : 'protocol.buttons.removeStimulus'  | trans}}
                        </button>
                        <span class="drag-btn float-right">draggable</span>
                      </div>
                    </div>
                  </div>
                </draggable>
              </div>

              <div class="col-md-12 mt-2">
                <button type="button"
                        class="btn btn-info"
                        @click.prevent="addTask()">
                  {{isChain ? 'protocol.addStep' : isShaping ? 'protocol.buttons.addСriterion' : 'protocol.buttons.addStimulus' |
                  trans}}
                </button>
              </div>
              <!----------- tasks ------------------->
            </div>
          </div>

          <!-----------  mand-reaction-goal------------------->
          <div class="mt-2"
               v-if="isMand">
            <div class="form-group row">
              <div class="col-md-12">
                <h4 class="row-title">{{'protocol.list_of_mand_reaction' | trans}}</h4>
                <h5 class="row-title_subsitle">{{'protocol.change_mand_reaction_position' | trans}}</h5>
              </div>


              <div class="tasks col-md-12" id="mandGoal" v-if="protocol.globalMandReactions">

                <draggable
                    :list="protocol.globalMandReactions"
                    ghost-class="ghost"
                    @start="draggingGlobalTasks = true"
                    @end="draggingGlobalTasks = false"
                    handle=".drag-btn"
                >

                  <div v-for="(value, key) in protocol.globalMandReactions" class="alert-secondary dragging-block">
                    <div class="form-group row dragging">
                      <div class="col-md-9 col-10">

                        <mdc-textfield type="text"
                                       :ref="'task_' + key"
                                       :name="'task_' + key"
                                       :label="'protocol.describeMandReaction', {number: key + 1} | trans"
                                       class="required"
                                       :class="{'is-invalid': errors.has('task_' + key)}"
                                       v-validate="'required|max:1000|unique_task'"
                                       v-model="value.description"
                                       v-on:change="setStageMandDescription(value,$event)"
                                       data-vv-validate-on="none"
                                       :data-vv-as="'protocol.describeMandReaction', {number: key + 1} | trans"/>
                        <span class="invalid-feedback"
                              v-if="errors.has('task_' + key)">
                                    <strong>{{ errors.first('task_' + key) }}</strong>
                                </span>
                        <button type="button"
                                v-if="(showDeleteButton || isCurator || isBCBA) && key && isMobile"
                                class="btn btn-link secondary-link btn-sm"
                                @click.prevent="removeMandModal(protocol.globalMandReactions[key].uuid)">
                          {{'protocol.buttons.removeStimulus' | trans}}
                        </button>
                      </div>
                      <div class="col-2 text-center" v-if="isMobile">
                        <span class="drag-btn">draggable</span>
                      </div>
                      <div class="col-md-3" v-if="!isMobile">
                        <button type="button"
                                v-if="(showDeleteButton || isCurator || isBCBA) && key"
                                class="btn btn-link secondary-link btn-sm"
                                @click.prevent="removeMandModal(protocol.globalMandReactions[key].uuid)">
                          {{'protocol.buttons.removeStimulus' | trans}}
                        </button>
                        <span class="drag-btn float-right ml-1">draggable</span>
                      </div>
                    </div>
                  </div>
                </draggable>
              </div>

              <div class="col-md-12 mt-2">
                <button type="button"
                        class="btn btn-info"
                        @click.prevent="addMand()">
                  {{'protocol.buttons.addMandReaction' |
                  trans}}
                </button>
              </div>
              <!----------- mand-reaction-goal ------------------->
            </div>
          </div>

          <!----------- stages ------------------->

          <protocol-criteration
              :protocol="protocol"
              :setIsChanged="setIsChanged"
              :visible="visible"
              :errors="errors"
              :selectedTeachingMethodID="selectedTeachingMethodID"
          />

          <div class="form-group row form-group-button">
            <div class="col-md-12">

              <button v-if="protocol.isDraft" type="submit"
                      class="btn btn-primary btn-sm mr-2 mb-2 mb-md-0"
                      @click.prevent="editProtocol(protocol.published)">
                {{'protocol.buttons.apply_changes_to_protocol' | trans}}
              </button>
              <button v-if="!isNew && !protocol.isDraft" type="submit"
                      class="btn btn-primary btn-sm mr-2 mb-2 mb-md-0"
                      @click.prevent="editProtocol(true)">
                {{'protocol.buttons.save' | trans}}
              </button>
              <button v-if="isNew && !protocol.isDraft" type="submit"
                      class="btn btn-primary btn-sm mr-2"
                      @click.prevent="createProtocol(true)"
                      :disabled="!canPublish">
                {{'protocol.buttons.create' | trans}}
              </button>
              <button
                  v-if="!(isNew) && !(clientId || protocol.assigneeId) && !protocol.isDraft"
                  type="submit"
                  class="btn btn-link btn-sm mr-2 mb-2 mb-md-0"
                  @click.prevent="editProtocol(false)"
                  :disabled="disabled">
                {{'protocol.buttons.createNotPublish' | trans}}
              </button>
              <button v-if="(isNew) && !protocol.isDraft"
                      type="submit"
                      class="btn btn-link btn-sm mr-2 mb-2 mb-md-0"
                      @click.prevent="createProtocol(false)"
                      :disabled="disabled">
                {{'protocol.buttons.createNotPublish' | trans}}
              </button>
              <button v-if="protocol.isOnIndividualization"
                      type="submit"
                      class="btn btn-primary btn-sm mr-2 mb-2 mb-md-0"
                      @click.prevent="saveAndAllowMensuration()"
                      :disabled="disabled">
                {{'protocol.buttons.save_and_allow_mensuration' | trans}}
              </button>
              <router-link class="btn btn-primary btn-sm mr-2 mb-2 mb-md-0"
                           v-if="clientId || protocol.assigneeId"
                           :to="{ name: 'client-edit', params: { clientId: clientId || protocol.assigneeId}}">
                <span>{{'protocol.buttons.cancel' | trans}}</span>
              </router-link>
              <router-link class="btn btn-primary btn-sm mr-2" v-else
                           :to="{ name: 'protocols'}">
                <span>{{'protocol.buttons.cancel' | trans}}</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>

    </div>

    <tasks
        v-if="listTasks"
        v-on:editProtocol="editProtocol(true)"
        v-on:createProtocol="createProtocol(true)"
        v-on:hideTasks="hideTasks"
        v-on:changeCanPublish="changeCanPublish"
        v-on:protocolChanged="setIsChanged(true)"
        v-bind:protocol="protocol"
        :protocol="protocol"
        :taskTypes="taskNotDttTypes"
        :selectedTaskTypeTitle="selectedTaskTypeTitle"
        :selectedStagesTitle="selectedStagesTitle"
        :is-new="isNew"
        :change-from-client="!showDeleteButton">
    </tasks>

    <tasks-d-t-t
        v-if="listTasksDTT"
        v-on:editProtocol="editProtocol(true)"
        v-on:createProtocol="createProtocol(true)"
        v-on:hideTasks="hideTasks"
        v-on:changeCanPublish="changeCanPublish"
        v-on:protocolChanged="setIsChanged(true)"
        v-bind:protocol="protocol"
        :protocol="protocol"
        :showDeleteButton="showDeleteButton"
        :transferConditionValue="transferConditionValue"
        :taskTypes="taskTypes"
        :selectedTaskTypeTitle="selectedTaskTypeTitle"
        :selectedStagesTitle="selectedStagesTitle"
        :is-new="isNew"
        :change-from-client="!showDeleteButton">
    </tasks-d-t-t>

    <tasks-usd
        v-if="listTasksUSD"
        v-on:editProtocol="editProtocol(true)"
        v-on:createProtocol="createProtocol(true)"
        v-on:hideTasks="hideTasks"
        v-on:changeCanPublish="changeCanPublish"
        v-on:protocolChanged="setIsChanged(true)"
        :protocol="protocol"
        :taskTypes="taskTypes"
        :selectedTaskTypeTitle="selectedTaskTypeTitle"
        :selectedStagesTitle="selectedStagesTitle"
        :is-new="isNew"
        :change-from-client="!showDeleteButton"/>


    <tasks-mand
        v-if="listTasksMand"
        v-on:editProtocol="editProtocol(true)"
        v-on:createProtocol="createProtocol(true)"
        v-on:hideMands="hideMands"
        v-on:changeCanPublish="changeCanPublish"
        v-on:protocolChanged="setIsChanged(true)"
        v-bind:protocol="protocol"
        :protocol="protocol"
        :showDeleteButton="showDeleteButton"
        :transferConditionValue="transferConditionValue"
        :taskTypes="taskTypesMand"
        :selectedTaskTypeTitle="selectedTaskTypeTitle"
        :selectedStagesTitle="selectedStagesTitle"
        :is-new="isNew"
        :change-from-client="!showDeleteButton">
    </tasks-mand>

    <tasks-shaping
        v-if="listTasksShaping"
        v-on:editProtocol="editProtocol(true)"
        v-on:createProtocol="createProtocol(true)"
        v-on:hideTasks="hideTasks"
        v-on:changeCanPublish="changeCanPublish"
        v-on:protocolChanged="setIsChanged(true)"
        :protocol="protocol"
        :taskTypes="taskTypes"
        :selectedTaskTypeTitle="selectedTaskTypeTitle"
        :selectedStagesTitle="selectedStagesTitle"
        :is-new="isNew"
        :change-from-client="!showDeleteButton">
    </tasks-shaping>

    <tasks-chain
        v-if="listTasksChain"
        v-on:editProtocol="editProtocol(true)"
        v-on:createProtocol="createProtocol(true)"
        v-on:hideTasks="hideTasks"
        v-on:changeCanPublish="changeCanPublish"
        v-on:protocolChanged="setIsChanged(true)"
        :protocol="protocol"
        :taskTypes="taskNotDttTypes"
        :selectedTaskTypeTitle="selectedTaskTypeTitle"
        :selectedStagesTitle="selectedStagesTitle"
        :is-new="isNew"
        :change-from-client="!showDeleteButton">
    </tasks-chain>

    <tasks-pecs3
        v-if="listTasksPecsWithDiscrimination"
        v-on:editProtocol="editProtocol(true)"
        v-on:createProtocol="createProtocol(true)"
        v-on:hidePecsWithDiscrimination="hideTasks"
        v-on:changeCanPublish="changeCanPublish"
        v-on:protocolChanged="setIsChanged(true)"
        v-bind:protocol="protocol"
        :protocol="protocol"
        :showDeleteButton="showDeleteButton"
        :transferConditionValue="transferConditionValue"
        :selectedStagesTitle="selectedStagesTitle"
        :is-new="isNew"
        :change-from-client="!showDeleteButton"
    />

    <confirm-change-modal :visible="isOpen"
                          v-on:close="cancel" v-on:accept="accept">
    </confirm-change-modal>

    <mdc-dialog v-model="isTaskDeleteOpen"
                :title="'protocol.confirm_delete' | trans"
                :accept="'user.save' | trans"
                :cancel="'user.cancel' | trans"
                @accept="acceptDelete"
                @cancel="cancelDelete"/>

    <mdc-dialog v-model="isMandDeleteOpen"
                :title="'protocol.confirm_delete_mand' | trans"
                :accept="'user.save' | trans"
                :cancel="'user.cancel' | trans"
                @accept="acceptDeleteMand"
                @cancel="cancelDeleteMand"/>

    <mdc-dialog v-model="isModalAcceptPopup"
                :title="isShaping ? 'protocol.delete_criteria_title' : 'protocol.delete_set' | trans"
                :accept="'buttons.continue' | trans"
                :cancel="'user.cancel' | trans"
                @accept="changeStimul"
                @cancel="closeStimul">

    </mdc-dialog>

    <mdc-dialog v-model="isModalCantDelete"
                :title="'protocol.description_on_delete' | trans"
                :accept="'buttons.continue' | trans"
                @accept="closeStimul">

    </mdc-dialog>



    <div v-if="changedSavePopup">
      <change-fixing-modal
          :visible="changedSavePopup"
          :protocol="protocol"
          :client="client"
          :disabledNotImportantChanges="disabledNotImportantChanges"
          @accept="acceptSave"
          @cancel="cancelSave"/>
    </div>


  </div>
</template>

<script>
  import $ from 'jquery';
  import hash from 'object-hash';
  import axios from 'axios';
  import lang from '../../../lang/translator';
  import {DIRECTORY_TYPES, TRANSFER_CONDITION} from '../../protocols/constants.js';
  import autocompleteSearch from '../../../common/autocompleteSearch/components/autocompleteSearch';
  import debounce from 'lodash/debounce';
  import isUndefined from 'lodash/isUndefined';
  import isEmpty from 'lodash/isEmpty';
  import parseInt from 'lodash/parseInt';
  import forIn from 'lodash/forIn';
  import forEach from 'lodash/forEach';
  import differenceBy from 'lodash/differenceBy';
  import findIndex from 'lodash/findIndex';
  import Tasks from './Tasks';
  import TasksDTT from './TasksDTT';
  import TasksMand from './TasksMand';
  import TasksUsd from './TasksUSD';
  import TasksChain from './TasksChain';
  import TasksShaping from './TasksShaping';
  import ConfirmChangeModal from './ConfirmChangeModal';
  import Hints from './Hints';
  import Loader from '../../loader/components/Loader';
  import uniqBy from 'lodash/uniqBy';
  import filter from 'lodash/filter';
  import trim from 'lodash/trim';
  import moment from 'moment';
  import Constants from '../../undesirableBehavior/Constants';
  import cloneDeep from 'lodash/cloneDeep';
  import {Validator} from 'vee-validate';
  import draggable from 'vuedraggable';
  import {mapGetters} from 'vuex';
  import Manager from '../../profile/api/Manager';
  import ChangeFixingModal from './ChangeFixingModal';
  import UuidGenerator from '@/common/uuid/UuidGenerator';
  import map from 'lodash/map';
  import sortBy from 'lodash/sortBy';
  import isEqual from 'lodash/isEqual';
  import ProtocolInfo from './Protocollnfo';
  import ProtocolCriteration from './ProtocolCriteration';
  import TasksPecs from './TasksPecs';
  import CriteriaPecs from './CriteriaPecs';
  import CriteriaPecsItems from './CriteriaPecsItems';
  import TasksPecs3 from './TasksPecs3';

  export default {
    props: {
      'clientId': {
        type: [Number, String],
        default() {
          return null;
        },
      },
      'protocolId': {
        type: [Number, String],
        default() {
          return null;
        },
      },
      'clientProtocol': {
        type: Boolean,
        default() {
          return false;
        },
      },
      'isActiveProtocol': {
        type: Boolean,
        default() {
          return true;
        },
      },
    },

    data() {
      return {
        apiUrl: '/protocols/',
        apiClientUrl: '/users/clients/',
        applyings: [],
        skillFields: [],
        client: {},
        isOpen:false,
        isTaskDeleteOpen: false,
        isMandDeleteOpen: false,
        taskDeleteTitle: null,
        taskDeleteUuid: null,
        mandDeleteTitle: null,
        selectedTeachingMethodID: null,
        disabledTeachingMethod: false,
        dragging: false,
        draggingGlobalTasks: false,
        focusStage: false,
        protocol: {
          id: null,
          title: '',
          applying: '',
          skillField: '',
          teachingMethodDescription: '',
          goal: '',
          execution: '',
          criteriaEndSession: '',
          criteriaEndTeaching: '',
          criteriaEndProtocol: '',
          synthesisStrategy: '',
          materials: '',
          teachingFormat: '',
          risingPrompt: '',
          dataFields: [],
          published: false,
          shortcutMenuTitle: '',
          isShortcutEnabled: false,
          stages: [{
            id: null,
            position: 0,
            title: lang.get('protocol.stage') + ' ' + 0,
            titleDescription: lang.get('protocol.stage') + ' ' + 0,
            description: '',
            attemptCount: '10',
            tasks: [],
            mands: [],
            phases: [
              {
                typeId: 1,
                transferCondition: {
                  id: null
                },
                minFieldCount: '2',
                maxFieldCount: '8',
                taskType: null,
              },
              {
                typeId: 2,
                transferCondition: {
                  id: null
                },
                minFieldCount: '2',
                maxFieldCount: '8',
                taskType: null,
              },
              {
                typeId: 3,
                intervals: []
              }
            ]
          }],
          isNew: true,
          teachingMethodId: null,
          intervals: [],
          globalTasks: [],
          globalMandReactions: [],
          isOnIndividualization: false
        },
        hintListRotation: null,
        validateStimuls: true,
        validateCheckList: true,
        errorStages: true,
        errorStagesCount: true,
        selectedInterval: null,
        columns: ['name', 'count', 'action'],
        dataFields: [
          'baseLevel',
          'code1',
          'code2',
          'errorCorrection',
          'features',
          'hintType',
          'instruction',
          'provideHint',
          'reductionHint',
          'reductionHintMethod',
          'rightReaction',
          'teachingMethod',
        ],
        templates: [],
        directories: [],
        taskTypes: [],
        taskTypesMand: [],
        taskNotDttTypes: [],
        disabled: false,
        isNew: true,
        isEditing: false,
        listTasks: false,
        listTasksDTT: false,
        listTasksMand: false,
        listTasksUSD: false,
        listTasksChain: false,
        listTasksShaping: false,
        listTasksPecs: false,
        listTasksPecsWithDiscrimination: false,
        taskTypeTitle: '',
        selectedTaskTypeTitle: '',
        selectedStagesTitle: '',
        canPublish: false,
        isLoaded: true,
        visible: true,
        showDeleteButton: true,
        isChanged: false,
        isChangedTask: true,
        isChangedMand: true,
        teachingMethod: null,
        selectedTeachingMethod: null,
        transferConditionValue:{
          first:'',
          second:'',
          third:'',
          fourth:''
        },
        masteringTransferCondition: null,
        rotationTransferCondition: null,
        fluencyTransferCondition: null,
        intervalId: null,
        taskIntervalId: null,
        mandIntervalId: null,
        changedSavePopup: false,
        disabledNotImportantChanges: false,
        update: false,
        published: false,
        mandDeleteUiid: null,
        isModalAcceptPopup: false,
        selectedTaskUuid: null,
        globalTask: null,
        stagesTask: null,
        categories: null,
        allTaskTypes: null,
        isModalCantDelete: false,
        hashProtocol: null,
        countRemovedCategory: 0,
        isAllTasksEnabled: false
      };
    },

    components: {
      CriteriaPecs, CriteriaPecsItems, TasksPecs3, Tasks, Loader, autocompleteSearch, Hints, TasksDTT, draggable,ChangeFixingModal, TasksMand, ConfirmChangeModal, TasksUsd, TasksChain,TasksShaping, ProtocolInfo, ProtocolCriteration, TasksPecs
    },

    computed: {

      ...mapGetters('auth', [
        'isCurator',
        'isBCBA',
      ]),
      ...mapGetters('mobile', [
        'isMobile',
      ]),

      isDTT: function() {
        return this.selectedTeachingMethodID == 1;
      },

      isSimple: function() {
        return this.selectedTeachingMethodID == 2;
      },

      isMand: function() {
        return this.selectedTeachingMethodID == 3;
      },

      isUSD: function () {
        return this.selectedTeachingMethodID == 4;
      },

      isChain: function () {
        return this.selectedTeachingMethodID == 5;
      },

      isShaping(){
        return this.selectedTeachingMethodID == 6
      },

      isPecs(){
        return this.selectedTeachingMethodID == 7
      },

      isPecsWithoutDiscrimination(){
        return this.selectedTeachingMethodID == 8
      },

      isPecsWithDiscrimination(){
        return this.selectedTeachingMethodID == 9
      },

      isPecsWithItems(){
        return this.selectedTeachingMethodID == 10
      },

      activeStages(){
        return filter(this.protocol.stages, stage => {return stage.isActive});
      }

    },

    provide () {
      return { parentValidator: this.$validator }
    },

    mounted: function() {
      this.$nextTick(function() {
        this.intervalId = window.setInterval(() => {
          let hashProtocol = hash.MD5(this.protocol);

          if ((!!this.hashProtocol && hashProtocol !== this.hashProtocol))  {
            this.setIsChanged(false);
            this.autoSave();
          }

          if(!this.hashProtocol){
            this.hashProtocol  = hashProtocol;
          }

        }, 15000);

      });
    },

    beforeDestroy() {
      if(this.intervalId){
        clearInterval(this.intervalId)
      }
    },


    created() {
      this.isLoaded = false;
      this.fetchTaskTypes();
      this.fetchDirectories();
      this.fetchHint();


      this.transferConditionValue.first = TRANSFER_CONDITION.ONE_TRIAL;
      this.transferConditionValue.second = TRANSFER_CONDITION.TRIAL_IN_A_ROW;
      this.transferConditionValue.third = TRANSFER_CONDITION.SESSION_IN_A_ROW;
      this.transferConditionValue.fourth = TRANSFER_CONDITION.RATIO;
      Validator.extend('unique_task', {
        getMessage: attribute => this.protocol.teachingMethodId != 3 ? lang.get('validation.unique_task',{attribute}) : lang.get('protocol.unique_mand', {attribute}),
        validate: async (task) => {
          let valid;
          let unique = 0;

          if(this.protocol.teachingMethodId != 3) {
            forIn(this.protocol.globalTasks, function(item) {
              if (trim(item.description) === trim(task)) {
                unique++;
              }
            });
          } else{
            forIn(this.protocol.globalMandReactions, function(item) {
              if (trim(item.description) === trim(task)) {
                unique++;
              }
            });
          }

          if (unique > 1) {
            valid = false;
          } else {
            valid = true;
          }

          return {valid};
        },
      });

      Validator.extend('unique_stage', {
        getMessage: attribute => lang.get('validation.unique_stage',
            {attribute}),
        validate: async (stage) => {
          let valid;
          let unique = 0;

          forIn(this.protocol.stages, function(item) {
            if (trim(item.description) === trim(stage)) {
              unique++;
            }
          });

          if (unique > 1) {
            valid = false;
          } else {
            valid = true;
          }

          return {valid};
        },
      });


    },

    methods: {


      validatorTaskAdd(){
        Validator.extend('unique_task', {
          getMessage: attribute => this.protocol.teachingMethodId != 3 ? lang.get('validation.unique_task',{attribute}) : lang.get('protocol.unique_mand', {attribute}),
          validate: async (task) => {
            let valid;
            let unique = 0;

            if(this.protocol.teachingMethodId != 3) {
              forIn(this.protocol.globalTasks, function(item) {
                if (trim(item.description) === trim(task)) {
                  unique++;
                }
              });
            } else{
              forIn(this.protocol.globalMandReactions, function(item) {
                if (trim(item.description) === trim(task)) {
                  unique++;
                }
              });
            }

            if (unique > 1) {
              valid = false;
            } else {
              valid = true;
            }

            return {valid};
          },
        });
      },

      onMoveStages({ relatedContext, draggedContext }) {
        const relatedElement = relatedContext.element;
        const draggedElement = draggedContext.element;
        return (
            (!relatedElement || !relatedElement.isClosed) && !draggedElement.isClosed
        );
      },

      setIsChanged: function(isChanged = true) {
        this.isChanged = isChanged;
      },
      autoSave: async function() {
        if (!this.protocol.assigneeId){

          this.protocol.teachingMethodId = this.teachingMethod.id;
          this.protocol.isNew = this.isNew;
          if(this.protocol.teachingMethodId != 8 &&
              this.protocol.teachingMethodId != 9 &&
              this.protocol.teachingMethodId != 10) {
            this.reindexStages();
          }
          if(this.protocol.teachingMethodId != 3 &&
              this.protocol.teachingMethodId != 7 &&
              this.protocol.teachingMethodId != 8 &&
              this.protocol.teachingMethodId != 9 &&
              this.protocol.teachingMethodId != 10) {
            this.reindexTasks();
          }

          if(this.protocol.teachingMethodId == 3){
            this.reindexMands();
          }

          if(this.protocol.teachingMethodId == 7 || this.protocol.teachingMethodId == 8){
            this.masteredStimuliList();
          }

          if(this.protocol.teachingMethodId == 9 || this.protocol.teachingMethodId == 10){
            this.criteriaPecsDescriptionChanged();
          }

          this.hintListActivate();

          let protocol = cloneDeep(this.protocol);

          protocol.teachingMethod = this.teachingMethod;

          let urlSave = this.apiUrl + 'draft/';

          switch (this.teachingMethod.id) {
            case 1:
              urlSave = this.apiUrl + 'draft/dtt/';
              break;
            case 2:
              urlSave = this.apiUrl + 'draft/simple/';
              break;
            case 3:
              urlSave = this.apiUrl + 'draft/mand/';
              break;
            case 4:
              urlSave = this.apiUrl + 'draft/vcd/';
              break;
            case 5:
              urlSave = this.apiUrl + 'draft/chain/';
              break;
            case 6:
              urlSave = this.apiUrl + 'draft/shaping/';
              break;
            case 7:
              urlSave = this.apiUrl + 'draft/pecs-sentence-structure/';
              break;
            case 8:
              urlSave = this.apiUrl + 'draft/pecs-without-discrimination/';
              break;
            case 9:
              urlSave = this.apiUrl + 'draft/pecs-with-discrimination/';
              break;
            case 10:
              urlSave = this.apiUrl + 'draft/pecs-features-with-items/';
              break;
          }


          if(this.protocol.teachingMethodId == 3){

            protocol.globalMandReactions = uniqBy(this.protocol.globalMandReactions, 'description');

            if (protocol.globalMandReactions.length != this.protocol.globalMandReactions.length){
              forIn(protocol.stages, (stage, index) => {
                protocol.stages[index].mands = filter(stage.mands, mand => {
                  let globalMand = filter(protocol.globalMandReactions, global => {
                    return global.uuid == mand.globalUuid;
                  })

                  if (globalMand.length){
                    return mand;
                  }
                });
              });
            }

          }

          if(this.protocol.teachingMethodId != 3 && this.protocol.teachingMethodId != 7 && this.protocol.teachingMethodId != 8 && this.protocol.teachingMethodId != 9 && this.protocol.teachingMethodId != 10){

            protocol.globalTasks = uniqBy(this.protocol.globalTasks, 'description');
            forIn(protocol.stages, (stage, index) => {
              protocol.stages[index].tasks = uniqBy(stage.tasks, 'description');
            });
          }

          protocol.stages = uniqBy(protocol.stages, 'description');

          let response = null;
          if (this.protocol.id) {
            response = await axios.post(urlSave + this.protocol.id, protocol);
          } else{
            response = await axios.post(urlSave, protocol);
          }

          if (response){

            let protocol = response.data.data;
            let dataFields = protocol ? protocol.dataFields : null;
            for (let [key, value] of Object.entries(dataFields)) {
              if (['Отсутствует', 'No'].includes(value)) {
                dataFields[key] = lang.get('protocol.absent');
              } else if (!value) {
                dataFields[key] = '';
              }
            }
            this.protocol.id = protocol.id;
            this.protocol.bcbaId = protocol.bcbaId;
            this.hashProtocol = hash.MD5(this.protocol);
          }
        }
      },

      validate() {
        this.errors.clear();
        this.intervalError = false;
        if (this.$refs.searchSkillField){
          this.$refs.searchSkillField.validate();
        }
      },

      validateForm: async function() {
        let that = this;
        this.validate();
        let result = await this.$validator.validateAll();

        if (!result) {
          that.handleValidationErrorAdvanced();
        }

        return that.errors.items.length == 0;
      },

      validateStimul: async function() {
        this.validateStimuls = true;
        let validateCheckList = true;
        forEach(this.protocol.stages, (item) => {
          item.notValid = false;
          if ((item.tasks.length == 1 && item.tasks[0].description == "") || !item.tasks.length){
            this.validateStimuls =  false;
          }
          if (!item.type){
            validateCheckList = false;
            item.notValid = true;
          }
        });
        return this.validateStimuls && validateCheckList;
      },

      validateMand: async function() {
        this.validateMands = true;
        this.validateCheckList = true;
        /*forEach(this.protocol.stages, (item) => {
          if ((item.tasks.length == 1 && item.tasks[0].description == "") || !item.tasks.length){
            this.validateMands =  false;
          }
        });*/
        return this.validateMands;
      },

      validateStages: async function() {
        this.errorStages = true;
        let validateStages = true;
        forIn(this.protocol.stages, (item) => {

          if(this.protocol.teachingMethodId == 6 || this.isShaping){
            item.notValid = false;

            if (!item.type){
              validateStages = false;
              item.notValid = true;
            }

          } else if(this.protocol.teachingMethodId == 2 || this.isSimple){
            item.notValid = false;

            if (!item.type || !item.targetStimulus.globalUuid){
              validateStages = false;
              item.notValid = true;
            }
          } else {
            forEach(item.phases, (phase) => {
              item.notValid = false;

              if (phase.active && phase.typeId !== 5){


                if (phase.typeId == 3) {
                  if (!phase.intervals.length ){
                    validateStages = false;
                    item.notValid = true;
                  }
                } else{
                  if (!phase.transferCondition.id){
                    validateStages = false;
                    item.notValid = true;
                  }
                }
              }

            });
          }



        });


        return validateStages;
      },


      getClient: async function(clientId) {
        try {
          let response = await axios.get(this.apiClientUrl + clientId);
          this.client = response.data.data;
        } catch (error) {
          console.dir(error);
        }
      },



      onChangeCriteriaEndSession(search) {
        this.setIsChanged(true);
        this.searchAutocomplete(DIRECTORY_TYPES.CRITERIA_END_SESSION, search,
            this);
      },

      onChangeCriteriaEndTeaching(search) {
        this.setIsChanged(true);
        this.searchAutocomplete(DIRECTORY_TYPES.CRITERIA_END_TEACHING, search,
            this);
      },

      onChangeCriteriaEndProtocol(search) {
        this.setIsChanged(true);
        this.searchAutocomplete(DIRECTORY_TYPES.CRITERIA_END_PROTOCOL, search,
            this);
      },



      setCriteriaEndSession(text) {
        this.protocol.criteriaEndSession = text;
        this.autocomplete = [];
      },

      setCriteriaEndTeaching(text) {
        this.protocol.criteriaEndTeaching = text;
        this.autocomplete = [];
      },

      setCriteriaEndProtocol(text) {
        this.protocol.criteriaEndProtocol = text;
        this.autocomplete = [];
      },

      fetchTaskTypes: async function() {

        try {

          let response = await axios.get(this.apiUrl + 'task-types/');

          this.allTaskTypes = response.data.data;

          this.taskTypesMand = this.allTaskTypes.filter((item) => {
            return item.id == 6;
          });

          let taskTypes = this.allTaskTypes.filter((item) => {
            return item.id !== 2 && item.id !== 6;
          });

          this.taskTypes = taskTypes;

          this.taskNotDttTypes = this.allTaskTypes.filter((item) => {
            return item.id !== 2 && item.id !== 1  && item.id !== 6;
          });


        } catch (error) {
          console.dir(error);
        }


      },


      fetchDirectories: async function() {
        try {
          let response = await axios.get(this.apiUrl + 'directories/');

          this.directories = response.data.data;

          if (this.protocolId && response) {
            this.loadProtocol();
          } else {
            this.loadFromTemplate();
          }

        } catch (error) {
          console.dir(error);
        }
      },

      fetchHint: async function() {
        try {
          let response = await Manager.getTaskTypes();
          this.hintListRotation = response.data.data.taskPrompts.prompts;
          forEach(this.hintListRotation, item => {
            item.active = false;
          });

        } catch (error) {
          console.dir(error);
        }
      },

      fetchTemplates: async function() {
        try {
          let response = await axios.get(this.apiUrl + 'templates/');
          this.templates = response.data.data;
        } catch (error) {
          console.dir(error);
        }
      },


      detectProtocol: async function() {
        try {
          let response = await axios.get(this.apiUrl + this.protocolId + '/teaching-method' );
          return response.data.data.id;
        } catch (error) {
          console.info(error)
          if (error.data.code == 404 || error.status !== 200) {
            this.$router.push({name: 'error'});
          }
        }
      },

      getListOfTasks: function() {

        let step = map( this.protocol.globalTasks, item => {

          return {
            description: item.description,
            title: item.title,
            globalTaskId: item.id,
            globalUuid: item.uuid,
            position: item.position,
            stageId: this.protocol.stages[0].id,
            stageUuid: this.protocol.stages[0].uuid
          };

        });


        this.$set(this.protocol.stages[0], 'tasks', step);

      },


      fetchProtocol: async function(id) {

        let teachingMethodId = await this.detectProtocol();

        if (teachingMethodId){
          try {
            let apiUrl = this.apiUrl;
            switch (teachingMethodId) {
              case 1:
                apiUrl = this.apiUrl + 'dtt/';
                break;
              case 2:
                apiUrl = this.apiUrl + 'simple/';
                break;
              case 3:
                apiUrl = this.apiUrl + 'mand/';
                break;
              case 4:
                apiUrl = this.apiUrl + 'vcd/';
                break;
              case 5:
                apiUrl = this.apiUrl + 'chain/';
                break;
              case 6:
                apiUrl = this.apiUrl + 'shaping/';
                break;
              case 7:
                apiUrl = this.apiUrl + 'pecs-sentence-structure/';
                break;
              case 8:
                apiUrl = this.apiUrl + 'pecs-without-discrimination/';
                break;
              case 9:
                apiUrl = this.apiUrl + 'pecs-with-discrimination/';
                break;
              case 10:
                apiUrl = this.apiUrl + 'pecs-features-with-items/';
                break;
            }
            let response =  await axios.get(apiUrl + id);
            let protocol = response.data.data;
            let dataFields = protocol.dataFields;
            for (let [key, value] of Object.entries(dataFields)) {
              if (['Отсутствует', 'No'].includes(value)) {
                dataFields[key] = lang.get('protocol.absent');
              } else if (!value) {
                dataFields[key] = '';
              }
            }

            let index = findIndex(this.directories, protocol.teachingMethod);

            this.teachingMethod = this.directories[index];
            protocol.dataFields = dataFields;
            this.protocol = protocol;

            this.protocol.skillField = protocol.skillField.name;

            if (this.teachingMethod.id != 3 &&
                this.teachingMethod.id != 7 &&
                this.teachingMethod.id != 8 &&
                this.protocol.teachingMethodId != 9 &&
                this.protocol.teachingMethodId != 10){
              this.orderTasks();
            }

            if (this.teachingMethod.id == 3){
              this.orderMands();
            }

            if(this.teachingMethod.id != 3 &&
                this.teachingMethod.id != 7 &&
                this.teachingMethod.id != 8 &&
                this.protocol.teachingMethodId != 9 &&
                this.protocol.teachingMethodId != 10) {
              this.reindexTasks();
            }

            if(this.protocol.teachingMethodId == 3){
              this.reindexMands();
            }

            if(this.protocol.teachingMethodId == 8 || this.teachingMethod.id == 8){
              this.getListOfTasks();
            }


            if (this.protocol.assigneeId) {
              this.disabledTeachingMethod = true;

              if(!(this.isMand || this.protocol.teachingMethod.id == 3)){
                this.globalTask = cloneDeep(this.protocol.globalTasks)
              }

              if(this.isMand || this.protocol.teachingMethod.id == 3){
                this.globalTask = cloneDeep(this.protocol.globalMandReactions)
              }

              if(this.isPecsWithDiscrimination || this.protocol.teachingMethod.id == 9 ||
                  this.isPecsWithItems || this.protocol.teachingMethod.id == 10){
                this.categories = cloneDeep(this.protocol.categories);
              }

            }

            if ((this.teachingMethod.id == 1 || this.teachingMethod.id == 4 || this.teachingMethod.id == 2) && !protocol.globalTasks.length){
              this.addTask();
            }

            if (this.teachingMethod.id == 3 && !protocol.globalMandReactions){
              this.addMand();
            }

            if (this.protocol.assigneeId && this.protocol.stages.length) {

              if(this.isPecsWithoutDiscrimination || this.protocol.teachingMethod.id == 8){
                this.isAllTasksEnabled = this.protocol.isAllTasksEnabled;
              }

              forEach(this.protocol.stages, (item) => {

                if(this.isUSD || this.protocol.teachingMethod.id == 4 ||
                    this.isChain || this.protocol.teachingMethod.id == 5){
                  item.activeCount = item.stimuli.length
                }

                if(this.isDTT || this.protocol.teachingMethod.id == 1){
                  item.activeCount = filter(item.tasks, 'active').length
                }

                if(this.isMand || this.protocol.teachingMethod.id == 3){
                  item.activeCount = item.mands ? item.mands.length : 0;
                }

                if(this.isChain || this.protocol.teachingMethod.id == 5){
                  item.masteredCount = item.masteredStimuli ? item.masteredStimuli.length : 0;
                }

                if(this.isSimple || this.protocol.teachingMethod.id == 2 ||
                    this.isPecsWithDiscrimination || this.protocol.teachingMethod.id == 9 ||
                    this.isPecsWithItems || this.protocol.teachingMethod.id == 10 ||
                    this.isPecs || this.protocol.teachingMethod.id == 7 ||
                    this.isPecsWithoutDiscrimination || this.protocol.teachingMethod.id == 8){
                  item.masteredCount = item.masteredTasks ? item.masteredTasks.length : 0;
                }


                if(this.isShaping || this.protocol.teachingMethod.id == 6){
                  item.targetStimulusUuid = item.targetStimulus ? item.targetStimulus.globalUuid : null;
                }

                if(this.isMand || this.protocol.teachingMethod.id == 3){
                  item.masteredCount = item.masteredMands ? item.masteredMands.length : 0;
                }

                if (this.isDTT || this.protocol.teachingMethod.id == 1 || this.isMand || this.protocol.teachingMethod.id == 3  || this.isUSD || this.protocol.teachingMethod.id == 4) {
                  item.fixed = item.hasAssignedStage ?
                      item.hasAssignedStage :
                      false;


                } else {

                  if (this.protocol.status) {
                    if (this.protocol.status.id == 1) {
                      item.fixed = false;
                    } else {
                      item.fixed = !item.isNew
                    }
                  }
                }

              });

            }

            if (this.clientId || this.protocol.assigneeId) {
              this.getClient(this.clientId || this.protocol.assigneeId);
            }
            if (this.protocol.status) {
              if (this.protocol.status.id != 1) {
                this.showDeleteButton = false;
              }
            }

            if (this.protocol.stages.length && this.protocol.stages[0].hasAssignedStage) {
              this.showDeleteButton = false;
            }

            this.hashProtocol = hash.MD5(this.protocol);


            setTimeout(() => {
              this.isEditing = true;
            }, 100)

          } catch (error) {
            console.dir(error);
            if (error.status == 403) {
              this.$router.push({name: 'client'});
            }
          } finally {
            this.isLoaded = true;
          }
        }


      },

      setProtocolFromTemplate: function(template) {
        this.protocol.templateId = template.id;
        let dataFields = template.dataFields;
        for (let [key, value] of Object.entries(dataFields)) {
          if (['Отсутствует'].includes(value)) {
            dataFields[key] = lang.get('protocol.absent');
          }
        }
        this.protocol.dataFields = dataFields;
        this.protocol.stages = [];
      },

      otherFields: function(key) {
        return !this.dataFields.includes(key);
      },

      stageHaveEmptyTitle: function() {
        let isEmptyTitle = false;
        this.protocol.stages.forEach(function(item, index) {
          if (isUndefined(item['description']) ||
              item['description'].length < 1) {
            isEmptyTitle = true;
          }
        });

        return isEmptyTitle;
      },

      stageFocus: function() {
        this.$nextTick(() => {
          let index = this.protocol.stages.length - 1;
          let focusStage = 'stage_' + index;
          let input = this.$refs[focusStage][0];
          input.focus();
        });
      },

      reindexStages: function() {
        this.protocol.stages.forEach(function(item, index) {
          let position = (parseInt(index) + 1);
          item['position'] = parseInt(index);
          item['title'] = lang.get('protocol.stage') + ' ' + position;
          item['titleDescription'] = lang.get('protocol.stage') + ' ' +
              position + ': ' + item['description'];
        });
      },

      reindexTasks: function() {

        if (this.protocol.globalTasks && this.protocol.globalTasks.length){
          this.protocol.globalTasks.forEach(function(item, index) {
            let position = (parseInt(index) + 1);
            item['position'] = parseInt(index);
            item['title'] =  lang.get('protocol.stimulus') + ' ' + position;
          });
        }

        if (this.protocol.stages && this.protocol.stages.length) {
          this.protocol.stages.forEach(item => {
            if (this.isShaping || this.isChain) {
              item.stimuli.forEach(function(task, index) {
                let position = (parseInt(index) + 1);
                task['position'] = parseInt(index);
                task['title'] = lang.get('protocol.stimulus') + ' ' + position;
              });
            } else {

              item.tasks.forEach(function(task, index) {
                let position = (parseInt(index) + 1);
                task['position'] = parseInt(index);
                task['title'] = lang.get('protocol.stimulus') + ' ' + position;
              });
            }

          });
        }
      },


      hintListActivate: function() {
        this.protocol.stages.forEach(function(item, index) {

          if(item.taskPrompts){
            if (item.taskPrompts[2].active || item.taskPrompts[3].active || item.taskPrompts[4].active || item.taskPrompts[5].active){
              item.taskPrompts[1].active = false;
            }
          }

        });
      },

      reindexMands: function() {
        if (this.protocol.globalMandReactions && this.protocol.globalMandReactions.length) {
          this.protocol.globalMandReactions.forEach(function(item, index) {
            let position = (parseInt(index) + 1);
            item['position'] = parseInt(index);
            //item['title'] =  lang.get('protocol.stimulus') + ' ' +  parseInt(index);
          });
        }

        if (this.protocol.stages && this.protocol.stages.length) {
          this.protocol.stages.forEach(function(item) {
            item.mands.forEach(function(task, index) {
              let position = (parseInt(index) + 1);
              task['position'] = parseInt(index);
              task['title'] = lang.get('protocol.stimulus') + ' ' +
                  parseInt(index);
            });
          });
        }

      },

      masteredStimuliList: function() {

        this.protocol.stages.forEach((item,index) => {

          let masteredStimuli =  filter(item.tasks, item => {

             if ((this.selectedTeachingMethod && this.selectedTeachingMethod.id == 8) || (this.teachingMethod && this.teachingMethod.id == 8)){
               return (!this.protocol.isAllTasksEnabled && (item.position == 3 || item.position == 4) && item.mastered) ||
                      (this.protocol.isAllTasksEnabled && item.mastered)
             } else {
               return item.mastered
             }

          });

          this.$set(this.protocol.stages[index], 'masteredStimuli', masteredStimuli);
          this.$set(this.protocol.stages[index], 'masteredTasks', masteredStimuli);

        });

      },

      criteriaPecsDescriptionChanged: function() {

        this.protocol.stages.forEach((item,index) => {

          forEach(item.tasks, task => {

              let currentCategory = filter(this.protocol.categories, category => {return task.categoryUuid === category.uuid})[0];
              let currentTask = currentCategory ? filter(currentCategory.tasks, taskCategory => {return taskCategory.uuid === task.globalUuid})[0] : null;

              task.description = currentTask ?  currentTask.description : task.description;

          });

          let masteredStimuli =  filter(item.tasks, item => {
            return item.mastered;
          });

          this.$set(this.protocol.stages[index], 'masteredStimuli', masteredStimuli);
          this.$set(this.protocol.stages[index], 'masteredTasks', masteredStimuli);

        });

      },

      orderTasks: function() {
        sortBy(this.protocol.globalTasks, 'position');
        this.protocol.stages.forEach(function(item) {
          item.tasks = sortBy(item.tasks, 'position');
        });
      },

      orderMands: function() {
        sortBy(this.protocol.globalMandReactions, 'position');
        this.protocol.stages.forEach(function(item) {
          item.mands = sortBy(item.mands, 'position');
        });
      },

      addStage: function(newProtocol = false) {
        this.setIsChanged(true);
        if (!this.stageHaveEmptyTitle()) {
          this.protocol.stages.push(this.newStage());
        }

        if (this.teachingMethod.id == 3 && !this.protocol.globalMandReactions){
          this.$set(this.protocol, 'globalMandReactions', []);
          //this.protocol.globalMandReactions = [];
          this.addMand();
        }

        if ((this.teachingMethod.id == 1 || this.teachingMethod.id == 4 || this.teachingMethod.id == 5 || this.teachingMethod.id == 2)  && (!this.protocol.globalTasks || !this.protocol.globalTasks.length)){
          this.$set(this.protocol, 'globalTasks', []);
          //this.protocol.globalTasks = [];
          this.addTask();
        }

        if (!newProtocol) this.stageFocus();
        this.changeCanPublish();
        return true;
      },

      duplicateStage: function(stage) {
        this.setIsChanged(true);
        this.changeCanPublish();
        let position = (parseInt(this.protocol.stages.length) + 1);
        let newStage = cloneDeep(stage);
        newStage.id = null;
        newStage.position = position;

        newStage.isNew = true;
        newStage.isClosed = false;
        newStage.hasAssignedStage = false;
        newStage.changed = true;
        newStage.uuid = UuidGenerator.v4();
        newStage.description = stage.description + ' - ' + position +' (' + lang.get('protocol.copy') +
            ')';
        newStage.title = lang.get('protocol.stage') + ' ' + position;
        newStage.titleDescription = lang.get('protocol.stage') + ' ' + position;

        if (this.teachingMethod.id != 3 && this.teachingMethod.id != 4) {

          forEach(newStage.tasks, task => {
            task.id = null;
            task.phaseId = null;
            task.stageId = null;
            task.isNew = true;
            task.uuid = UuidGenerator.v4();

          });

        }

        if (this.teachingMethod.id == 1) {

          newStage.changed = newStage.isNew ? newStage.changed : true;

          forEach(newStage.phases, phase => {
            phase.id = null;
            phase.stageId = null;
            phase.phaseId = null;
          });

          let intervals = filter(newStage.phases, function(item) {
            return item.typeId == 3;
          })[0].intervals;

          forEach(intervals, interval => {
            interval.id = null;
            interval.phaseId = null;
            if (!interval.typeId) {
              interval.typeId = 1;
            }
          });
        }


        if (this.teachingMethod.id == 4) {

          let intervals = filter(newStage.phases, function(item) {
            return item.typeId == 3;
          })[0].intervals;

          forEach(intervals, interval => {
            interval.id = null;
            interval.phaseId = null;
            if (!interval.typeId) {
              interval.typeId = 1;
            }
          });

          let levels = filter(newStage.phases, function(item) {
            return item.typeId == 5;
          })[0].levels;

          forEach(levels, level => {
            let levelUiid = UuidGenerator.v4();
            let tasks = filter(newStage.stimuli, function(item) {
              return item.levelUuid == level.uuid;
            });

            forEach(tasks, task => {
              task.id = null;
              task.levelUuid = levelUiid;
            });

            level.uuid = levelUiid;

            forEach(level.groups, group => {
              let groupUiid = UuidGenerator.v4();
              let tasks = filter(newStage.stimuli, function(item) {
                return item.levelGroupUuid == group.uuid;
              });

              forEach(tasks, task => {
                task.id = null;
                task.levelGroupUuid = groupUiid;
              });

              group.uuid = groupUiid;
            });

          });

          forEach(newStage.stimuli, task => {
            task.id = null;
            //task.levelUuid = UuidGenerator.v4();
            //task.levelGroupUuid = UuidGenerator.v4();
          });
        }


        this.protocol.stages.push(newStage);
      },

      newStage: function() {
        this.setIsChanged(true);
        let position = (parseInt(this.protocol.stages.length) + 1);
        let globalTasks = [];
        let globalMandReactions = [];
        let uuidStage = UuidGenerator.v4().toString();

        if (this.teachingMethod.id != 3) {
          forEach(this.protocol.globalTasks, (item) => {
            globalTasks.push({
              globalTaskId: item.id,
              id: null,
              isNew: true,
              changed: false,
              position: item.position,
              active: true,
              phaseType: 1,
              description: item.description,
              fieldIndex: 1,
              title: item.title,
              uuid: UuidGenerator.v4(),
              globalUuid: item.uuid,
            })
          });
        }

        let recordedReactionsList = [];

        if (this.teachingMethod.id == 3) {
          forEach(this.protocol.globalMandReactions, (item) => {
            globalMandReactions.push({
              position: item.position,
              description: item.description,
              globalUuid: item.uuid,
              isNew: true,
            })
          });

          let recordedReactions = this.taskTypesMand[0].answers;

          recordedReactionsList = map(recordedReactions, (reactions) => {
            return reactions.id
          });
        }

        return {
          id: null,
          uuid: uuidStage,
          position: parseInt(this.protocol.stages.length),
          title: lang.get('protocol.stage') + ' ' + position,
          titleDescription: lang.get('protocol.stage') + ' ' + position,
          description: '',
          attemptCount: '10',
          tasks: globalTasks,
          stimuli: globalTasks,
          type: null,
          mands: globalMandReactions,
          isNew: true,
          isPromptEnabled: false,
          taskPrompts: cloneDeep(this.hintListRotation),
          recordedReactions: recordedReactionsList,
          masteringCondition: (this.teachingMethod.id == 3 || this.isMand || this.teachingMethod.id == 5 || this.isChain || this.teachingMethod.id == 6 || this.isShaping) ? {
            ratio: 100,
            trialCount: 3,
            sessionCount: 1,
            answerDirectory: {id: 1}
          } : null,
          phases: (this.teachingMethod.id == 1) ? [
            {
              typeId: 1,
              transferCondition: {
                id: null
              },
              minFieldCount: '2',
              maxFieldCount: '8',
              taskType: null,
              active: true,
              withFields: true,
              isPromptEnabled: false,
              taskPrompts: cloneDeep(this.hintListRotation)
            },
            {
              typeId: 2,
              transferCondition: {
                id: null
              },
              minFieldCount: '2',
              maxFieldCount: '8',
              taskType: null,
              active: true,
              withFields: true,
              isPromptEnabled: false,
              taskPrompts: cloneDeep(this.hintListRotation)
            },
            {
              typeId: 4,
              transferCondition: {
                id: null
              },
              minFieldCount: '2',
              maxFieldCount: '8',
              taskType: null,
              active: true,
              withFields: true,
              isPromptEnabled: false,
              taskPrompts: cloneDeep(this.hintListRotation)
            },
            {
              typeId: 3,
              intervals: [],
              active: true
            }
          ] : (this.teachingMethod.id == 4) ? [
            {
              typeId: 5,
              masteringConditions: {
                nextLevel: {
                  ratio: 90,
                  blockCount: 9
                },
                previousLevel: {
                  ratio: 90,
                  blockCount: 9
                },
                nextPhase: {
                  ratio: 90,
                  blockCount: 9
                }

              },
              minFieldCount: '2',
              maxFieldCount: '8',
              taskType: null,
              active: true,
              withFields: true,
              isPromptEnabled: false,
              taskPrompts: cloneDeep(this.hintListRotation),
              levels: [
                {
                  "uuid": UuidGenerator.v4(),
                  "description": lang.get('protocol.delay_none'),
                  "index": 1,
                },
                {
                  "uuid": UuidGenerator.v4(),
                  "description": lang.get('protocol.delay',{sec: 2}),
                  "index": 2
                },
                {
                  "uuid": UuidGenerator.v4(),
                  "description": lang.get('protocol.delay',{sec: 4}),
                  "index": 3
                }
              ]
            },{
              typeId: 3,
              intervals: [],
              active: true
            }
          ] :''
        };
      },

      removeStage: function(index) {
        this.setIsChanged(true);
        try {
          if (index !== -1) {
            this.protocol.stages.splice(index, 1);
            this.reindexStages();
          }

          this.changeCanPublish();
        } catch (error) {
          console.dir(error);
          return false;
        }

        return true;
      },

      editProtocol: async function(published = false) {
        this.saveProtocol(true, published);
      },

      createProtocol: async function(published = false) {
        this.saveProtocol(false, published);
      },
      saveAndAllowMensuration: async function() {
        this.protocol.isMensurationAllowed = true;
        this.saveProtocol(true, true);
      },
      isEmptyLastStage: function() {
        let lastIndex = this.protocol.stages.length - 1;
        if (lastIndex > 0) {
          return this.protocol.stages[lastIndex].description.length < 1
              && this.protocol.stages[lastIndex].tasks.length < 1;
        }
        return false;
      },

      stageLastIndex: function() {
        return this.protocol.stages.length - 1;
      },

      handleValidationErrorAdvanced() {
        const firstField = Object.keys(this.errors.collect())[0];
        if(this.$refs[`${firstField}`]){
          if (this.$refs[`${firstField}`].$el) {
            this.$refs[`${firstField}`].$el.scrollIntoView();
          } else if (this.$refs[`${firstField}`][0]){
            this.$refs[`${firstField}`][0].$el.scrollIntoView();
          } else{
            this.$refs[`${firstField}`].scrollIntoView();
          }
        }

      },

      setTransferCondition(condition, conditionValue) {

        if (condition.id == TRANSFER_CONDITION.TRIAL_IN_A_ROW){
          condition['trialCount'] = conditionValue.trialCount;

        } else if (condition.id == TRANSFER_CONDITION.SESSION_IN_A_ROW){
          condition['sessionCount'] = conditionValue.sessionCount;

        } else if (condition.id == TRANSFER_CONDITION.RATIO){
          condition['ratio'] = conditionValue.ratio;
          condition['trialCount'] = conditionValue.conditionTrial;
          condition['sessionCount'] = conditionValue.conditionSession;
        }

      },

      getTransferCondition(condition, conditionValue) {

        if (conditionValue.id == TRANSFER_CONDITION.TRIAL_IN_A_ROW){
          condition.trialCount = conditionValue.trialCount;

        } else if (conditionValue.id == TRANSFER_CONDITION.SESSION_IN_A_ROW){
          condition.sessionCount = conditionValue.sessionCount;

        } else if (conditionValue.id == TRANSFER_CONDITION.RATIO){
          condition.ratio = conditionValue.ratio;
          condition.conditionTrial = conditionValue.trialCount;
          condition.conditionSession = conditionValue.sessionCount;
        }

      },

      changedTeachingMethod(){
        this.teachingMethod = this.selectedTeachingMethod;
        this.protocol.teachingMethodId = this.selectedTeachingMethod.id;
        this.protocol.teachingMethod = this.selectedTeachingMethod;
        this.protocol.dataFields.teachingMethod = this.selectedTeachingMethod.name;
        this.$set(this.protocol, 'stages', []);

        if(this.teachingMethod.id != 3) {
          this.$set(this.protocol, 'globalTasks', []);
        } else{
          this.$set(this.protocol, 'globalMandReactions', []);
        }

        if (this.selectedTeachingMethod.id == 7 || this.teachingMethod.id == 7 || this.selectedTeachingMethod.id == 8 || this.teachingMethod.id == 8){
          this.addPecsStages();
        } else{
          this.$set(this.protocol, 'teachingMethodDescription', "");
          this.$set(this.protocol, 'skillField', "");
          this.protocol.stages.push(this.newStage());
          this.addPecsStages();
        }

        if (this.selectedTeachingMethod.id == 9 || this.teachingMethod.id == 9 || this.selectedTeachingMethod.id == 10 || this.teachingMethod.id == 10){
          this.addPecsWithDiscriminationStages();
        }


        if (this.selectedTeachingMethod.id == 1){
          this.selectedTeachingMethodID = this.selectedTeachingMethod.id;
          this.rotationTransferCondition = TRANSFER_CONDITION.ONE_TRIAL;
          this.fluencyTransferCondition = TRANSFER_CONDITION.ONE_TRIAL;
          this.masteringTransferCondition = TRANSFER_CONDITION.ONE_TRIAL;
          this.addTask();

        } else{
          this.selectedTeachingMethodID = this.selectedTeachingMethod.id;
        }

        if (this.selectedTeachingMethod.id == 3){
          this.addMand();
        }

        if (this.selectedTeachingMethod.id == 4 || this.selectedTeachingMethod.id == 6 || this.selectedTeachingMethod.id == 2 || this.selectedTeachingMethod.id == 5){
          this.addTask();
        }

      },

      accept(){
        this.toggleConfirmChangeModal();
        this.changedTeachingMethod()
      },

      toggleConfirmChangeModal() {
        this.isOpen = !this.isOpen;
        this.isEditing = true;
      },

      cancel(){
        let method = this.directories[findIndex(this.directories, this.protocol.teachingMethod)];
        this.isEditing = false;
        this.teachingMethod = method;
        this.selectedTeachingMethodID = this.teachingMethod.id;
        this.protocol.dataFields.teachingMethod = this.teachingMethod.name;


        setTimeout(() => {
          this.toggleConfirmChangeModal();
        }, 100);


      },

      validateAllStage: async function(){
        let validateStimulList = true;
        let validateStages = true;
        let validateCountStages = true;
        let result = await this.validateForm();

        if (this.teachingMethod.id == 1 || this.isDTT || this.teachingMethod.id == 4 || this.isUSD
            || this.teachingMethod.id == 6 || this.isShaping) {
          validateStages = await this.validateStages();
          this.errorStages = validateStages;
        }

        if (this.teachingMethod.id == 2 || this.isSimple) {
          validateStages = await this.validateStimul();
          this.errorStages = validateStages;
        }

        if (this.teachingMethod.id == 3 || this.isMand){
          validateStimulList = await this.validateMand();
          this.reindexMands();
        }


        this.errorStagesCount = this.protocol.stages.length;

        return result && validateStimulList && validateStages && this.errorStagesCount;
      },


      postProtocol: async function() {
        this.disabled = true;
        this.isLoaded = false;
        if (this.teachingMethod.id != 9 && this.teachingMethod.id != 8 && this.teachingMethod.id != 10) {
          this.reindexStages();
        }
        this.setPublished(this.published);

        let validateError = await this.validateAllStage();

        if (validateError) {
          this.setIsChanged(false);

          let isSaved = false;

          if (this.teachingMethod.id == 1 || this.teachingMethod.id == 4 || this.teachingMethod.id == 5) {
            this.protocol.isNew = this.isNew;
            this.reindexTasks();
          }

          if (this.teachingMethod.id == 7) {
            this.changePecsStages();
            this.masteredStimuliList();
          }

          if (this.teachingMethod.id == 8) {
            this.masteredStimuliList();
          }

          if (this.teachingMethod.id == 9 || this.teachingMethod.id == 10) {
            this.criteriaPecsDescriptionChanged();
          }

          this.hintListActivate();


          try {
            let url;

            switch (this.teachingMethod.id) {
              case 1:
                url = this.apiUrl + 'dtt/';
                break;
              case 2:
                url = this.apiUrl + 'simple/';
                break;
              case 3:
                url = this.apiUrl + 'mand/';
                break;
              case 4:
                url = this.apiUrl + 'vcd/';
                break;
              case 5:
                url = this.apiUrl + 'chain/';
                break;
              case 6:
                url = this.apiUrl + 'shaping/';
                break;
              case 7:
                url = this.apiUrl + 'pecs-sentence-structure/';
                break;
              case 8:
                url = this.apiUrl + 'pecs-without-discrimination/';
                break;
              case 9:
                url = this.apiUrl + 'pecs-with-discrimination/';
                break;
              case 10:
                url = this.apiUrl + 'pecs-features-with-items/';
                break;
            }

            if (this.update || this.protocol.id) {
              this.protocol.id = this.protocolId ?
                  this.protocolId :
                  this.protocol.id;

              isSaved = await axios.put(url + this.protocol.id,
                  this.protocol);

            } else{

              isSaved = await axios.post(url, this.protocol)

            }

            if (isSaved) {
              if (this.protocol.assigneeId) {
                this.$router.push({
                  name: 'client-edit',
                  params: {clientId: this.protocol.assigneeId},
                });
              } else {
                this.$router.push({name: 'protocols'});
              }
            }
          } catch (error) {
            console.dir(error);

          }
        }
        this.disabled = false;
        this.isLoaded = true;
        if (!this.errorStages || !this.errorStagesCount){
          setTimeout(() => {
            this.$refs.stages.scrollIntoView();
          }, 100);
        }
      },

      onChangeRemovedCategoryCount: function() {
        this.countRemovedCategory++;
      },


      saveProtocol: async function(update = false, published = false) {
        /*if (this.isEmptyLastStage()) {
          this.removeStage(this.stageLastIndex());
        }*/

        this.update = update;
        this.published = published;

        if (this.teachingMethod.id == 9 || this.teachingMethod.id == 10) {
          this.criteriaPecsDescriptionChanged();
        }

        if (this.teachingMethod.id == 8 || this.teachingMethod.id == 7) {
          this.masteredStimuliList();
        }


        if (this.protocol.assigneeId && !this.protocol.isOnIndividualization) {
          let validateError = await this.validateAllStage();
          if(validateError){

            let newTask;

            if(this.isDTT || this.protocol.teachingMethod.id == 1 ||
                this.isUSD || this.protocol.teachingMethod.id == 4 ||
                this.isChain || this.protocol.teachingMethod.id == 5 ||
                this.isSimple || this.protocol.teachingMethod.id == 2 ||
                this.isShaping || this.protocol.teachingMethod.id == 6){
              newTask = this.protocol.globalTasks
            }

            if(this.isMand || this.protocol.teachingMethod.id == 3){
              newTask = this.protocol.globalMandReactions
            }

            if(this.isDTT || this.protocol.teachingMethod.id == 1 ||
                this.isUSD || this.protocol.teachingMethod.id == 4 ||
                this.isChain || this.protocol.teachingMethod.id == 5  ||
                this.isSimple || this.protocol.teachingMethod.id == 2 ||
                this.isShaping || this.protocol.teachingMethod.id == 6  ||
                this.isMand || this.protocol.teachingMethod.id == 3) {
 
              if (!isEqual(newTask, this.globalTask)) {
                this.disabledNotImportantChanges = true;
              }
            }

            if(this.isPecsWithDiscrimination || this.protocol.teachingMethod.id == 9 ||
                this.isPecsWithItems || this.protocol.teachingMethod.id == 10) {

              if(this.countRemovedCategory){
                this.disabledNotImportantChanges = true;
              }

              forEach(this.protocol.categories, category => {

                let currentCategory = filter(this.categories, item => {return item.uuid === category.uuid})[0];

                if (currentCategory){

                  if(this.isPecsWithDiscrimination || this.protocol.teachingMethod.id == 9) {
                    if (category.currentStage.uuid !==
                        currentCategory.currentStage.uuid) {
                      this.disabledNotImportantChanges = true;
                    }
                  }

                  let notNewTasks = filter(category.tasks, task => {return !task.isNew;});

                  if(+notNewTasks.length < +currentCategory.tasks.length){
                    this.disabledNotImportantChanges = true;
                  }

                }

              });

            }

            if(this.isPecsWithoutDiscrimination || this.protocol.teachingMethod.id == 8){

              if (this.isAllTasksEnabled !== this.protocol.isAllTasksEnabled){
                this.disabledNotImportantChanges = true;
              }

            }


            forEach(this.protocol.stages, (item) => {
              

              if(this.isUSD || this.protocol.teachingMethod.id == 4 ||
                  this.isChain || this.protocol.teachingMethod.id == 5){

                if (item.activeCount !== item.stimuli.length){
                  this.disabledNotImportantChanges = true;
                }

              }

              if(this.isDTT || this.protocol.teachingMethod.id == 1){
                let tesksCount = filter(item.tasks, 'active').length;
                if (item.activeCount !== tesksCount){
                  this.disabledNotImportantChanges = true;
                }
              }


              if(this.isMand || this.protocol.teachingMethod.id == 3){
                if (item.activeCount !== item.mands.length){
                  this.disabledNotImportantChanges = true;
                }
              }

              if(this.isChain || this.protocol.teachingMethod.id == 5){
                if (item.masteredCount && item.masteredStimuli && item.masteredCount !== item.masteredStimuli.length){
                  this.disabledNotImportantChanges = true;
                }
              }

              if(this.isMand || this.protocol.teachingMethod.id == 3){
                if (item.masteredCount && item.masteredCount !== item.masteredMands.length){
                  this.disabledNotImportantChanges = true;
                }
              }

              if(this.isSimple || this.protocol.teachingMethod.id == 2 ||
                 this.isPecsWithItems || this.protocol.teachingMethod.id == 10 ||
                 this.isPecsWithDiscrimination || this.protocol.teachingMethod.id == 9 ||
                  this.isPecs || this.protocol.teachingMethod.id == 7 ||
                  this.isPecsWithoutDiscrimination || this.protocol.teachingMethod.id == 8){

                if (item.masteredTasks && item.masteredCount !== item.masteredTasks.length){
                  this.disabledNotImportantChanges = true;
                }
              }

              if(this.isShaping || this.protocol.teachingMethod.id == 6){
                if (item.targetStimulus.globalUuid !== item.targetStimulusUuid){
                  this.disabledNotImportantChanges = true;
                }
              }

              if(this.isPecsWithItems || this.protocol.teachingMethod.id == 10){

                item.type = this.allTaskTypes.filter((item) => {
                  return item.id == 1;
                })[0];

              }



            });


            this.disabledTeachingMethod = true;
            this.changedSavePopup = true;

          }


        } else{
          this.postProtocol();
        }


      },

      selectChangeValue: function(field) {
        if (typeof(this.protocol.dataFields[field]) === 'object') {
          this.protocol.dataFields[field] = this.protocol.dataFields[field].name;
          this.protocol.dataFields['teahingMethodId'] = this.protocol.dataFields[field].id;
          this.setIsChanged(true);
        }
      },

      setPublished: function(value = true) {
        this.protocol.published = value;
      },

      showTasks: async function(task) {

        if (this.$refs['task_0']){

          if (this.$refs['task_0'][0]){
            let input = this.$refs['task_0'][0];
            input.blur();
          }

        }

        this.$nextTick(function() {
          this.taskIntervalId = window.setInterval(() => {
            if (this.isChangedTask) {
              this.showStagesTask(task);
              clearInterval(this.taskIntervalId)
            }
          }, 100);

        });

      },

      showMands: async function(mand) {

        if (this.$refs['task_0']){

          if (this.$refs['task_0'][0]){
            let input = this.$refs['task_0'][0];
            input.blur();
          }

        }

        this.$nextTick(function() {
          this.mandIntervalId = window.setInterval(() => {
            if (this.isChangedMand) {
              this.showStagesMand(mand);
              clearInterval(this.mandIntervalId)
            }
          }, 100);

        });


      },

      showStagesTask: async function(task) {
        if (!this.isPecsWithoutDiscrimination && !this.isPecsWithDiscrimination) {
          this.reindexStages();
        }
        this.validate();
        let result = await this.validateForm();

        if (!result) {
          return;
        }

        this.selectedStagesTitle = task.title;

        if (this.isDTT) {

          this.listTasksDTT = true;
        }
        if (this.isSimple) {

          this.listTasks = true;
        }
        if (this.isUSD) {

          this.listTasksUSD = true;
        }
        if (this.isChain) {

          this.listTasksChain = true;
        }
        if (!this.isMand) {

          if (task.tasks.length && this.listTasksDTT) {

            this.selectedTaskTypeTitle = this.getTaskTypeTitle(
                task.tasks[0].typeId);
          }
          if (task.tasks.length && this.listTasks &&
              task.tasks[0].typeId !== 1 && task.tasks[0].typeId !== 2) {

            this.selectedTaskTypeTitle = this.getTaskTypeTitle(
                task.tasks[0].typeId);
          }
        }

        if (this.isShaping) {
          this.listTasksShaping = true;
        }

        if (this.isPecsWithDiscrimination) {
          this.listTasksPecsWithDiscrimination = true;
        }

        this.$nextTick(() => {
          $('html,body').animate({scrollTop: 0}, 500);
        });
      },



      showStagesMand: async function(mand) {
        this.reindexStages();
        this.validate();
        let result = await this.validateForm();

        if (!result) {
          return;
        }

        this.selectedStagesTitle = mand.title;
        this.listTasksMand = true;

        this.$nextTick(() => {
          $('html,body').animate({scrollTop: 0}, 500);
        });

      },

      hideTasks: function() {

        if (this.isDTT) {
          this.listTasksDTT = false;
        } else if (this.isUSD) {
          this.listTasksUSD = false;
        } else if (this.isChain) {
          this.listTasksChain = false;
        } else if (this.isShaping) {
          this.listTasksShaping = false;
        } if (this.isPecsWithDiscrimination) {
          this.listTasksPecsWithDiscrimination = false;
        }else {
          this.listTasks = false;
        }

        this.disabled = false;
        this.errors.clear();
        this.validateStimuls = true;
        this.validateCheckList = true;
        this.changeCanPublish();
        this.validatorTaskAdd();

        setTimeout(() => {
          if(this.$refs['stage_0']){
            this.$refs['stage_0'][0].$el.scrollIntoView();
          }

        }, 200);
      },

      hideMands: function() {

        this.listTasksMand = false;
        this.disabled = false;
        this.errors.clear();
        this.changeCanPublish();

        setTimeout(() => {
          this.$refs['stage_0'][0].$el.scrollIntoView();
        }, 200);
      },


      loadProtocol: async function() {
        this.isNew = false;
        await this.fetchProtocol(this.protocolId);
        this.isLoaded = true;
        this.changeCanPublish();
        this.setIsChanged(false);


      },

      loadFromTemplate: async function() {
        this.isNew = true;

        this.selectedTeachingMethodID = this.directories[0].id;
        this.teachingMethod = this.directories[0];
        this.protocol.teachingMethod = this.directories[0];
        this.protocol.teachingMethodId = this.directories[0].id;

        await this.fetchTemplates();
        this.setProtocolFromTemplate(this.templates[0]);
        this.addStage(true);
        this.changeCanPublish();
        this.setIsChanged(false);
        setTimeout(() => {
          this.isEditing = true;
        }, 100);
        this.isLoaded = true;
        /*if ((this.protocol.teachingMethodId = 1) || (this.teachingMethod.id = 1)) {
          //this.addTask();
        }*/


      },

      getTaskTypeTitle: function(taskTypeId) {
        let taskTypeTitle = '';
        let taskType = this.taskTypes.filter(function(taskType) {
          return taskType.id === taskTypeId;
        });

        if (Array.isArray(taskType) && !isEmpty(taskType)) {
          taskTypeTitle = taskType.shift().title;
        }

        return taskTypeTitle;
      },

      toLocaleDateTimeTimezone(date) {
        let dateTime = new Date(date);
        let dateWithTimezone = dateTime.getTime() +
            (Math.abs(dateTime.getTimezoneOffset()) *
                Constants.SECONDS_PER_MINUTE * 1000);

        return moment(dateWithTimezone).format('DD.MM.YYYY HH:mm');
      },

      changeCanPublish: function() {
        let publish = true;
        forIn(this.protocol.stages, (value, key) => {
          if(!this.isMand && !this.isShaping && !this.isChain){
            if (value.tasks.length === 0) {
              publish = false;
            }
          }

          if(this.isShaping || this.isChain){
            if (value.stimuli.length === 0) {
              publish = false;
            }
          }

          if(this.isMand){
            if(!this.protocol.globalMandReactions){
              this.$set(this.protocol, 'globalMandReactions', []);
              //this.protocol.globalMandReactions = [];
            }
            if (this.protocol.globalMandReactions.length === 0) {
              publish = false;
            }
          }
        });

        this.canPublish = publish;
      },

      addTask: function() {
        this.setIsChanged(false);
        this.currentStageIndex = 0;
        this.protocol.stages[0].isNew = true;
        let position = parseInt(this.protocol.globalTasks.length) + 1;
        let uuid = UuidGenerator.v4();

        if(!this.protocol.globalTasks.length){
          this.$set(this.protocol, 'globalTasks', []);
        }


        this.$set(this.protocol.globalTasks, position - 1, {
          'id': null,
          'typeId': 1,
          'position': position,
          'title': lang.get('protocol.stimulus') + ' ' + position,
          'description': '',
          'isNew': true,
          'active': true,
          'uuid': uuid
        });
        

        forIn(this.protocol.stages, value => {
          if (!value.isClosed){

            if(this.isUSD || this.isChain || this.isShaping){

              let stimPositon  = parseInt(value.stimuli.length) + 1;
              this.$set(value.stimuli, stimPositon - 1, {
                'id': null,
                'globalTaskId': null,
                'position': stimPositon,
                'phaseType': 1,
                'title': lang.get('protocol.stimulus') + ' ' + stimPositon,
                'description': '',
                'isNew': true,
                'active': true,
                'uuid': UuidGenerator.v4(),
                'globalUuid': uuid,
                'target': false
              });

              if (this.isShaping && this.protocol.globalTasks.length === 1 ){
                if (!value.targetStimulus){
                  value.targetStimulus = {};
                  this.$set(value.targetStimulus, 'globalUuid',  uuid);
                }
              }

            } else{

              let tasksPositon  = parseInt(value.tasks.length) + 1;

              this.$set(value.tasks, tasksPositon - 1, {
                'id': null,
                'globalTaskId': null,
                'typeId': this.isDTT ? filter(value.phases, (item) =>{ return item.active; })[0].typeId : null,
                'position': tasksPositon,
                'fieldIndex': this.isDTT ? filter(value.phases, (item) =>{ return item.active; })[0].minFieldCount : null,
                'phaseType': 1,
                'title': lang.get('protocol.stimulus') + ' ' + tasksPositon,
                'description': '',
                'isNew': true,
                'active': true,
                'uuid': UuidGenerator.v4(),
                'globalUuid': uuid,
              });

            }

          }

        });
        

        if (position != 1) {

          let focusTask = 'task_' + (position - 1);
          setTimeout(() => {
            let input = this.$refs[focusTask][0];
            input.focus();
          }, 100)

        }
      },

      addMand: function() {
        this.setIsChanged(false);
        this.currentStageIndex = 0;
        this.protocol.stages[0].isNew = true;
        if(!this.protocol.globalMandReactions){
          this.$set(this.protocol, 'globalMandReactions', []);
          //this.protocol.globalMandReactions = [];
        }
        let position = parseInt(this.protocol.globalMandReactions.length) + 1;
        let uuid = UuidGenerator.v4();

        /*this.protocol.globalMandReactions.push({
          'id': null,
          'position': position,
          'title': lang.get('protocol.mands') + ' ' + position,
          'description': '',
          'uuid': uuid
        });*/

        this.$set(this.protocol.globalMandReactions, position - 1, {
          'id': null,
          'position': position,
          'title': lang.get('protocol.mands') + ' ' + uuid,
          'description': '',
          'uuid': uuid,
          'isNew': true,
        });


        forIn(this.protocol.stages, value => {
          if (!value.isClosed){
            value.mands.push({
              'position': position,
              'globalUuid': uuid,
              'isNew': true,
            });
          }

        });

        if (position != 1) {

          let focusMand = 'task_' + (position - 1);
          setTimeout(() => {
            let input = this.$refs[focusMand][0];
            input.focus();
          }, 100)

        }
      },


      setStageMandDescription: async function() {
        let position = parseInt(this.protocol.globalMandReactions.length) + 1;
        let validation = true;


        if (position != 1) {
          let task_input = 'task_' + (position - 2) ;

          validation = await this.$validator.validateAll();
          validation = await this.$validator.validate(task_input);

        }

        if (validation) {
          this.setIsChanged(true);
          this.changeCanPublish();
        } else{
          let focusTask = 'task_' + (position - 2);
          setTimeout(() => {
            let input = this.$refs[focusTask][0];
            input.focus();
          }, 100)
        }
      },

      setStageTaskDescription: async function(task) {

        let position = parseInt(this.protocol.globalTasks.length) + 1;
        let validation = true;

        if (position != 1) {
          let task_input = 'task_' + (position - 2) ;
          validation = await this.$validator.validate(task_input);
        }
        this.isChangedTask = false;
        let stagesLenght = this.protocol.stages.length;

        forIn(this.protocol.stages, (stage, index) => {

          let taskName = filter(stage.tasks, value => { return value.globalUuid == task.uuid});
          if(taskName.length){
            taskName[0].description = task.description;

            if (validation) {
              taskName[0].duplicate = false;
            } else{
              taskName[0].duplicate = true;
            }
          }

          if (stagesLenght - 1 == index){
            this.isChangedTask = true;
          }

        });

        if (validation) {

          this.protocol.globalTasks[position - 2].duplicate = false;
          this.setIsChanged(true);
          this.changeCanPublish();

        } else{
          this.protocol.globalTasks[position - 2].duplicate = true;

          let focusTask = 'task_' + (position - 2);
          setTimeout(() => {
            let input = this.$refs[focusTask][0];
            input.focus();
          }, 100)
        }
      },

      setStageDescription: async function(stage) {
        let position = parseInt(this.protocol.stages.length);
        let validation = true;

        if (position) {
          let task_input = 'stage_' + (position - 1) ;
          validation = await this.$validator.validate(task_input);
        }


      },


      focusStageTaskDescription: function(task) {
        this.setIsChanged(false);
      },

      removeTaskModal: function(taskUuid) {

        if(this.teachingMethod.id == 4 || this.teachingMethod.id == 6) {

          let taskCount = 0;
          let stimulCanDelete = true;


          forEach(this.protocol.stages, stage => {

            let currentTask = filter(stage.stimuli, stimul =>{
              return stimul.globalUuid === taskUuid;
            })[0];

            if((currentTask && currentTask.levelUuid && this.teachingMethod.id == 4) || (this.teachingMethod.id == 6 && currentTask && currentTask.globalUuid === stage.targetStimulus.globalUuid)){
              taskCount++;
            }

            if(this.teachingMethod.id == 6 && currentTask && currentTask.globalUuid === stage.targetStimulus.globalUuid && stage.stimuli.length === 1){
              stimulCanDelete = false;

            }

          });

          if(!stimulCanDelete){
            this.isModalCantDelete = true;
            return;
          }

          if (taskCount){
            this.isModalAcceptPopup = true;
            this.selectedTaskUuid = taskUuid;
          } else{
            this.removeTask(taskUuid);
          }

        } else{
          if ((this.isBCBA || this.isCurator) && !this.showDeleteButton){
            this.taskDeleteUuid = taskUuid;
            this.isTaskDeleteOpen = true;
          } else{
            this.removeTask(taskUuid);
          }
        }



      },

      changeStimul(){

        forIn(this.protocol.stages, (stage,index) => {

          let currentTask = filter(stage.stimuli, stimul =>{
            return stimul.globalUuid === this.selectedTaskUuid ;
          })[0];

          if(!this.isShaping && currentTask && currentTask.levelUuid){

            let mastering = filter(stage.phases, function(item) { return item.typeId == 5; })[0];
            let level = filter(mastering.levels, level => {
              return level.uuid == currentTask.levelUuid
            })[0];
            let groupIndex = findIndex(level.groups, group => {
              return group.uuid == currentTask.levelGroupUuid
            });

            let deleteTaskIndex = findIndex(stage.stimuli, deteted => {
              return deteted.globalUuid == this.selectedTaskUuid
            });

            stage.stimuli.splice(deleteTaskIndex, 1);

            let listSetTasks = filter(stage.stimuli, task =>{
              return currentTask.levelGroupUuid === task.levelGroupUuid
            });

            forEach(listSetTasks, task =>{
              delete task['levelUuid'];
              delete task['levelGroupUuid']
            });


            level.groups.splice(groupIndex, 1);


          }

          if(this.isShaping && currentTask && currentTask.globalUuid === stage.targetStimulus.globalUuid){

            let sortedTasks =  sortBy(stage.stimuli, 'position');

            let taskIndex = findIndex(sortedTasks, stimul =>{
              return stimul.globalUuid === this.selectedTaskUuid;
            });

            if (taskIndex > 0){

              this.$set(stage.targetStimulus, 'globalUuid', sortedTasks[taskIndex-1].globalUuid)

            } else{
              this.$set(stage.targetStimulus, 'globalUuid', sortedTasks[taskIndex+1].globalUuid)
            }


          }

        });
        this.removeTask(this.selectedTaskUuid);
        this.isModalAcceptPopup = false;
      },

      closeStimul(){
        this.isModalAcceptPopup = false;
        this.isModalCantDelete = false

      },

      removeMandModal: function(uuid) {

        if ((this.isBCBA || this.isCurator) && !this.showDeleteButton){
          this.mandDeleteUiid = uuid;
          this.isMandDeleteOpen = true;
        } else{
          this.removeMand(uuid);
        }

      },

      acceptDelete: function() {
        this.removeTask(this.taskDeleteUuid);
        this.isTaskDeleteOpen = false;
      },

      cancelDelete: function() {
        this.isTaskDeleteOpen = false;
      },

      acceptDeleteMand: function() {
        this.removeMand(this.mandDeleteUiid);
        this.isMandDeleteOpen = false;
      },

      cancelDeleteMand: function() {
        this.isMandDeleteOpen = false;
      },

      acceptSave: function(fixingChange, comment, fixingChangeDate) {
        if(fixingChange != '1'){
          this.protocol.changeFixing={
            isChangesImportant: fixingChange == '3',
            comment: comment,
            date: fixingChangeDate
          }
        }
        this.changedSavePopup = false;
        this.postProtocol();
      },

      cancelSave: function() {
        this.disabledNotImportantChanges = false;
        this.changedSavePopup = false;
      },

      removeTask: function(taskUuid) {

        let errorsList = this.errors.items.filter(function(items) {
          return items.rule != 'unique_task';
        });

        this.errors.items = errorsList;

        let currentTask = filter(this.protocol.globalTasks,
            function(task) {
              return task.uuid === taskUuid;
            });

        let taskIndex = findIndex(this.protocol.globalTasks,
            function(task) {
              return task.uuid === taskUuid;
            });

        if (taskIndex !== -1) {
          this.protocol.globalTasks.splice(taskIndex, 1);

          forIn(this.protocol.stages, value => {
            let taskStageIndex;
            if (this.isShaping || this.isChain){
              taskStageIndex =  findIndex(value.stimuli,
                  function(task) {
                    return task.globalUuid === taskUuid;
                  });

              value.stimuli.splice(taskStageIndex, 1);
            } else {

              taskStageIndex =  findIndex(value.tasks,
                  function(task) {
                    return task.globalUuid === taskUuid;
                  });

              value.tasks.splice(taskStageIndex, 1);
            }

          });

          if(this.protocol.teachingMethodId != 3 && this.protocol.teachingMethodId != 7 && this.protocol.teachingMethodId != 8 && this.protocol.teachingMethodId != 9 && this.protocol.teachingMethodId != 10) {
            this.reindexTasks();
          }

          if(this.protocol.teachingMethodId == 3){
            this.reindexMands();
          }
          this.changeCanPublish();
        }

        this.setIsChanged(true);
        return true;

      },

      removeMand: function(uuid) {

        let errorsList = this.errors.items.filter(function(items) {
          return items.rule != 'unique_mand';
        });

        this.errors.items = errorsList;

        let mandIndex = findIndex(this.protocol.globalMandReactions,
            function(mand) {
              return mand.uuid === uuid;
            });

        if (mandIndex !== -1) {
          this.protocol.globalMandReactions.splice(mandIndex, 1);

          forIn(this.protocol.stages, value => {
            let mandStageIndex = findIndex(value.mands,
                function(mand) {
                  return mand.globalUuid === uuid;
                });
            value.mands.splice(mandStageIndex, 1);
          });

          this.reindexMands();
          this.changeCanPublish();
        }

        this.setIsChanged(true);
        return true;

      },

      changePecsStages(){
        this.$set(this.protocol.stages[1], 'masteringCondition', this.protocol.stages[0].masteringCondition);
        this.$set(this.protocol.stages[2], 'masteringCondition', this.protocol.stages[0].masteringCondition);
        this.$set(this.protocol.stages[1], 'isPromptEnabled', this.protocol.stages[0].isPromptEnabled);
        this.$set(this.protocol.stages[2], 'isPromptEnabled', this.protocol.stages[0].isPromptEnabled);
        this.$set(this.protocol.stages[1], 'taskPrompts', this.protocol.stages[0].taskPrompts);
        this.$set(this.protocol.stages[2], 'taskPrompts', this.protocol.stages[0].taskPrompts);
      },

      addPecsStages(){

        if (this.teachingMethod.id == 7){

          this.$set(this.protocol, 'teachingMethodDescription', "NET");
          this.$set(this.protocol, 'skillField', "Манд");

          let globalTasks = [{
            description: lang.get('protocol.pecs.target_sequence.get_album'),
            title: 'protocol.pecs.target_sequence.get_album',
            id: null,
            uuid: UuidGenerator.v4(),
            position: 0,
          },
            {
              description: lang.get('protocol.pecs.target_sequence.get_i_want_card'),
              title: 'protocol.pecs.target_sequence.get_i_want_card',
              id: null,
              uuid: UuidGenerator.v4(),
              position: 1,
            },
            {
              description: lang.get('protocol.pecs.target_sequence.put_i_want_card'),
              title: 'protocol.pecs.target_sequence.put_i_want_card',
              id: null,
              uuid: UuidGenerator.v4(),
              position: 2,
            },
            {
              description: lang.get('protocol.pecs.target_sequence.get_reinforcement_item_card'),
              title: 'protocol.pecs.target_sequence.get_reinforcement_item_card',
              id: null,
              uuid: UuidGenerator.v4(),
              position: 3,
            },
            {
              description: lang.get('protocol.pecs.target_sequence.put_reinforcement_item_card'),
              title: 'protocol.pecs.target_sequence.put_reinforcement_item_card',
              id: null,
              uuid: UuidGenerator.v4(),
              position: 4,
            },
            {
              description: lang.get('protocol.pecs.target_sequence.get_template'),
              title: 'protocol.pecs.target_sequence.get_template',
              id: null,
              uuid: UuidGenerator.v4(),
              position: 5,
            },
            {
              description: lang.get('protocol.pecs.target_sequence.give_template'),
              title: 'protocol.pecs.target_sequence.give_template',
              id: null,
              uuid: UuidGenerator.v4(),
              position: 6,
            },
            {
              description: lang.get('protocol.pecs.target_sequence.read_sentence'),
              title: 'protocol.pecs.target_sequence.read_sentence',
              id: null,
              uuid: UuidGenerator.v4(),
              position: 7,
            }];

          let taskTypes = this.allTaskTypes.filter((item) => {
            return item.id == 4;
          })[0];

          let stageUuid1 = UuidGenerator.v4();

          let firstStep = map( [
            globalTasks[3],
            globalTasks[4],
            globalTasks[5],
            globalTasks[6],
          ], item => {

            return {
              description: item.description,
              title: item.title,
              globalTaskId: null,
              globalUuid: item.uuid,
              position: item.position,
              stageId: null,
              stageUuid: stageUuid1
            };

          });


          let stageUuid2 = UuidGenerator.v4();
          let secondStep = map( [
            globalTasks[0],
            globalTasks[1],
            globalTasks[2],
            globalTasks[3],
            globalTasks[4],
            globalTasks[5],
            globalTasks[6],
          ], item => {

            return {
              description: item.description,
              title: item.title,
              globalTaskId: null,
              globalUuid: item.uuid,
              position: item.position,
              stageId: null,
              stageUuid: stageUuid2
            };

          });


          let stageUuid3 = UuidGenerator.v4();
          let thirdStep = map( [
            ...globalTasks
          ], item => {

            return {
              description: item.description,
              title: item.title,
              globalTaskId: null,
              globalUuid: item.uuid,
              position: item.position,
              stageId: null,
              stageUuid: stageUuid3
            };

          });

          this.$set(this.protocol, 'stages', [
            {
              id: null,
              uuid: UuidGenerator.v4(),
              position: 0,
              title: 'protocol.pecs.step_one',
              description: lang.get('protocol.pecs.step_one'),
              tasks: firstStep,
              type: taskTypes,
              isNew: true,
              isPromptEnabled: false,
              taskPrompts: cloneDeep(this.hintListRotation),
              masteringCondition: {
                ratio: 100,
                trialCount: 3,
                sessionCount: 1,
                answerDirectory: {id: 1}
              }
            },
            {
              id: null,
              uuid: UuidGenerator.v4(),
              position: 1,
              title: 'protocol.pecs.step_two',
              description: lang.get('protocol.pecs.step_two'),
              tasks: secondStep,
              type: taskTypes,
              isNew: true,
              isPromptEnabled: false,
              taskPrompts: cloneDeep(this.hintListRotation),
              masteringCondition: {
                ratio: 100,
                trialCount: 3,
                sessionCount: 1,
                answerDirectory: {id: 1}
              }
            },
            {
              id: null,
              uuid: UuidGenerator.v4(),
              position: 2,
              title: 'protocol.pecs.step_three',
              description: lang.get('protocol.pecs.step_three'),
              tasks: thirdStep,
              type: taskTypes,
              isNew: true,
              isPromptEnabled: false,
              taskPrompts: cloneDeep(this.hintListRotation),
              masteringCondition: {
                ratio: 100,
                trialCount: 3,
                sessionCount: 1,
                answerDirectory: {id: 1}
              }
            }
          ]);

          this.$set(this.protocol, 'globalTasks', globalTasks);

        }

        if (this.teachingMethod.id == 8){

          this.$set(this.protocol, 'teachingMethodDescription', "");
          this.$set(this.protocol, 'skillField', "");

          let globalTasks = [{
            description: lang.get('protocol.pecs.without_discrimination_target_sequence.get_album'),
            title: 'protocol.pecs.without_discrimination_target_sequence.get_album',
            id: null,
            uuid: UuidGenerator.v4(),
            position: 0,
            enabled: true
          },
          {
            description: lang.get('protocol.pecs.without_discrimination_target_sequence.get_i_want_card'),
            title: 'protocol.pecs.without_discrimination_target_sequence.get_i_want_card',
            id: null,
            uuid: UuidGenerator.v4(),
            position: 1,
            enabled: true
          },
          {
            description: lang.get('protocol.pecs.without_discrimination_target_sequence.put_i_want_card'),
            title: 'protocol.pecs.without_discrimination_target_sequence.put_i_want_card',
            id: null,
            uuid: UuidGenerator.v4(),
            position: 2,
            enabled: true
          },
          {
            description: lang.get('protocol.pecs.without_discrimination_target_sequence.get_target_property_item_card'),
            title: 'protocol.pecs.without_discrimination_target_sequence.get_target_property_item_card',
            id: null,
            uuid: UuidGenerator.v4(),
            position: 3,
            enabled: false
          },
          {
            description: lang.get('protocol.pecs.without_discrimination_target_sequence.put_target_property_item_card'),
            title: 'protocol.pecs.without_discrimination_target_sequence.put_target_property_item_card',
            id: null,
            uuid: UuidGenerator.v4(),
            position: 4,
            enabled: false
          },
          {
            description: lang.get('protocol.pecs.without_discrimination_target_sequence.get_card_desired_item'),
            title: 'protocol.pecs.without_discrimination_target_sequence.get_card_desired_item',
            id: null,
            uuid: UuidGenerator.v4(),
            position: 5,
            enabled: true
          },
          {
            description: lang.get('protocol.pecs.without_discrimination_target_sequence.put_card_desired_item'),
            title: 'protocol.pecs.without_discrimination_target_sequence.put_card_desired_item',
            id: null,
            uuid: UuidGenerator.v4(),
            position: 6,
            enabled: true
          },
          {
            description: lang.get('protocol.pecs.without_discrimination_target_sequence.get_template'),
            title: 'protocol.pecs.without_discrimination_target_sequence.get_template',
            id: null,
            uuid: UuidGenerator.v4(),
            position: 7,
            enabled: true
          },
          {
            description: lang.get('protocol.pecs.without_discrimination_target_sequence.give_template'),
            title: 'protocol.pecs.without_discrimination_target_sequence.give_template',
            id: null,
            uuid: UuidGenerator.v4(),
            position: 8,
            enabled: true
          }];

          let taskTypes = this.allTaskTypes.filter((item) => {
            return item.id == 4;
          })[0];

          let stageUuid1 = UuidGenerator.v4();

          let firstStep = map( globalTasks, item => {

            return {
              description: item.description,
              title: item.title,
              globalTaskId: null,
              globalUuid: item.uuid,
              position: item.position,
              stageId: null,
              stageUuid: stageUuid1
            };

          });


          this.$set(this.protocol, 'stages', [
            {
              id: null,
              uuid: UuidGenerator.v4(),
              position: 0,
              title: 'protocol.pecs.step_one',
              description: lang.get('protocol.pecs.step_one'),
              tasks: firstStep,
              type: taskTypes,
              isNew: true,
              isAllTasksEnabled: true,
              isPromptEnabled: false,
              taskPrompts: cloneDeep(this.hintListRotation),
              masteringCondition: {
                ratio: 100,
                trialCount: 3,
                sessionCount: 1,
                answerDirectory: {id: 1}
              }
            }
          ]);

          this.$set(this.protocol, 'globalTasks', globalTasks);
          this.$set(this.protocol, 'isAllTasksEnabled', true);

        }


      },

      async getDefaultPecsCategories(){

        try {

          let response = await axios.get(this.apiUrl + 'default-categories/');

          return response.data.data;

        } catch (error) {
          console.dir(error);
        }

      },

      async addPecsWithDiscriminationStages(){

        let defaultPecsCategories = await this.getDefaultPecsCategories();

        this.$set(this.protocol, 'categories', []);

        let taskTypes = this.allTaskTypes.filter((item) => {
          return item.id == 1;
        })[0];


        this.$set(this.protocol, 'masteringCondition', {
          ratio: 100,
          trialCount: 3,
          sessionCount: 1,
          answerDirectory: {id: 1}
        });

        if(this.isPecsWithItems){

          this.$set(this.protocol, 'stages', [
            {
              id: null,
              uuid: UuidGenerator.v4(),
              position: 0,
              title: "count_properties1",
              description: lang.get('protocol.count_properties1'),
              tasks: [],
              type: taskTypes,
              isNew: true,
              isPromptEnabled: false,
              taskPrompts: cloneDeep(this.hintListRotation),
              isActive: true
            }
          ]);

        } else{
          this.$set(this.protocol, 'stages', [
            {
              id: null,
              uuid: UuidGenerator.v4(),
              position: 0,
              title: "count_properties1",
              description: lang.get('protocol.count_properties1'),
              tasks: [],
              type: taskTypes,
              isNew: true,
              isPromptEnabled: false,
              taskPrompts: cloneDeep(this.hintListRotation),
              isActive: true
            },
            {
              id: null,
              uuid: UuidGenerator.v4(),
              position: 1,
              title: "count_properties2",
              description: lang.get('protocol.count_properties2'),
              tasks: [],
              type: taskTypes,
              isNew: true,
              isPromptEnabled: false,
              taskPrompts: cloneDeep(this.hintListRotation),
              isActive: true
            },
            {
              id: null,
              uuid: UuidGenerator.v4(),
              position: 2,
              title: "count_properties3",
              description: lang.get('protocol.count_properties3'),
              tasks: [],
              type: taskTypes,
              isNew: true,
              isActive: true
            },
            {
              id: null,
              uuid: UuidGenerator.v4(),
              position: 3,
              title: "count_properties4",
              description: lang.get('protocol.count_properties4'),
              tasks: [],
              type: taskTypes,
              isNew: true,
              isActive: true
            }
          ]);
        }

        forEach(defaultPecsCategories, category => {

          let categoryUuid = UuidGenerator.v4().toString();
          let taskUuid = UuidGenerator.v4().toString();

          this.protocol.categories.push({
            'id': null,
            'uuid': categoryUuid,
            'currentStage': {
              id: this.protocol.stages[0].id,
              uuid: this.protocol.stages[0].uuid,
              description: this.protocol.stages[0].description,
              title: 'count_properties1',
              hasAssignedStage: false,
              isClosed: false,
            },
            'tasks': [{
              'description': "",
              'id': null,
              'position': 0,
              'protocolCategoryId': null,
              'protocolCategoryUuid': categoryUuid,
              'title': lang.get('protocol.property') + ' 1',
              'uuid': taskUuid,
              'isNew': true,
              'active': true,
            }],
            'title': lang.get(category.name),
            'masteringPercent': 0,
            'active': true,
            'typeId': 1
          });


          forIn(this.protocol.stages, (value, index) => {

            let indexTask =this.protocol.stages[index].tasks.length;

            this.protocol.stages[index].tasks.push({
              'id': null,
              'globalTaskId': null,
              'position': indexTask,
              'title': lang.get('protocol.property') + ' ' + indexTask,
              'description': '',
              'isNew': true,
              'active': true,
              'uuid': UuidGenerator.v4(),
              'globalUuid': taskUuid,
              'categoryUuid': categoryUuid,
            });


          });

        });

        if(this.isPecsWithItems){

          let categoryUuid = UuidGenerator.v4().toString();
          let taskUuid = UuidGenerator.v4().toString();
          let indexTask =this.protocol.stages[0].tasks.length;

          this.protocol.categories.push({
            'id': null,
            'uuid': categoryUuid,
            'currentStage': {
              id: this.protocol.stages[0].id,
              uuid: this.protocol.stages[0].uuid,
              description: this.protocol.stages[0].description,
              title: 'count_properties1',
              hasAssignedStage: false,
              isClosed: false,
            },
            'tasks': [{
              'description': "",
              'id': null,
              'position': indexTask,
              'protocolCategoryId': null,
              'protocolCategoryUuid': categoryUuid,
              'title': lang.get('protocol.property') + indexTask,
              'uuid': taskUuid,
              'isNew': true,
              'active': true,
            }],
            'title': lang.get('protocol.items'),
            'masteringPercent': 0,
            'active': true,
            'typeId': 2
          });

          this.protocol.stages[0].tasks.push({
            'id': null,
            'globalTaskId': null,
            'position': 1,
            'title': lang.get('protocol.property') + ' ' + 1,
            'description': '',
            'isNew': true,
            'active': true,
            'uuid': UuidGenerator.v4(),
            'globalUuid': taskUuid,
            'categoryUuid': categoryUuid,
          });

        }
      }

    },
    watch: {
      teachingMethod(newValue, oldValue){

        if(!this.protocol.teachingMethodId){
          this.$set(this.protocol, 'teachingMethodId', null)
        }

        if ((newValue.id == 7 && !this.protocol.stages.length)){
          this.addPecsStages();
        }

        if (this.isEditing) {

          if(!!this.protocol.stages[0].description){
            this.toggleConfirmChangeModal();
            this.selectedTeachingMethod = newValue;
            this.selectedTeachingMethodID = oldValue.id;
            this.protocol.dataFields.teachingMethod = newValue.name;
          } else{
            if (this.isNew && newValue.id != 7 && newValue.id != 8 && newValue.id != 9 && newValue.id != 10){
              this.selectedTeachingMethodID = newValue.id;
              this.protocol.stages = [];
              if (newValue.id != 3) {
                this.$set(this.protocol, 'globalTasks', []);
              } else{
                this.$set(this.protocol, 'globalMandReactions', []);
              }
              this.protocol.stages.push(this.newStage());
              if (newValue.id != 3) {
                this.addTask();
              }
              if (newValue.id == 3) {
                delete this.protocol['globalTasks'];
                this.addMand();
              }
              this.protocol.teachingMethodId = newValue.id;
              this.protocol.dataFields.teachingMethod = newValue.name;
              this.$set(this.protocol, 'teachingMethodDescription', "");
              this.$set(this.protocol, 'skillField', "");

            }

            if (this.isNew && newValue && (newValue.id == 7 || newValue.id == 8)){
              this.selectedTeachingMethod = newValue;
              this.selectedTeachingMethodID = newValue.id;
              this.protocol.teachingMethodId = newValue.id;
              this.protocol.teachingMethod = newValue;
              this.protocol.dataFields.teachingMethod = newValue.name;
              
   
              this.addPecsStages();
            }

            if (this.isNew && newValue && (newValue.id == 9 || newValue.id == 10)){

              this.selectedTeachingMethod = newValue;
              this.selectedTeachingMethodID = newValue.id;
              this.protocol.teachingMethodId = newValue.id;
              this.protocol.teachingMethod = newValue;
              this.protocol.dataFields.teachingMethod = newValue.name;

              this.addPecsWithDiscriminationStages();
            }
          }

        } else {
          this.protocol.teachingMethodId = newValue.id;
          this.selectedTeachingMethodID = newValue.id;
          this.protocol.dataFields.teachingMethod = newValue.name;
          this.fetchTaskTypes();

        }

        //this.validatorTaskAdd();


      },
      draggingGlobalTasks(val){
        if(!val){
          if(this.protocol.teachingMethodId != 3) {
            this.reindexTasks();
          }

          if(this.protocol.teachingMethodId == 3){
            this.reindexMands();
          }
        }
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/modules/protocols/components/Protocol.vue